(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

require('bootstrap/js/dist/tooltip');

require('../../../modules/modules');

var _utilities = require('./utilities');

var _objectFitImages = require('object-fit-images');

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import 'bootstrap/js/dist/alert'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/carousel'
// import 'bootstrap/js/dist/modal'
// import 'bootstrap/js/dist/popover'
// import 'bootstrap/js/dist/collapse'
jQuery(function ($) {
  $(document).ready(function () {
    outdatedBrowser({
      bgColor: '#f25648',
      color: '#ffffff',
      lowerThan: 'IE11',
      languagePath: '../node_modules/outdated-browser/outdatedbrowser/lang/en.html'
    });
    (0, _utilities.superscript)();
  });
  $(function () {
    (0, _objectFitImages2.default)();
  });

  $('.scroll-link').click(function (e) {
    e.preventDefault();
    $(this).blur();
    var string = $(this).attr('href').split('#')[1];
    $('#' + string).velocity('scroll', { duration: 400, offset: -250 });
    window.location.hash = '#' + string;
  });

  $(window).on('load', function () {
    if (window.location.hash) {
      var hash = window.location.hash;

      if ($(hash).length) {
        $(hash).velocity('scroll', { duration: 400, offset: -250 });
      }
    }
  });
});
// import '../node_modules/bootstrap/js/dist/collapse';

},{"../../../modules/modules":5,"./utilities":2,"bootstrap/js/dist/tooltip":3,"object-fit-images":4}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
==========================================================================
utility functions
==========================================================================
*/
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + ';path=/';
}

function getParam(p) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;

  var match = RegExp('[?&]' + p + '=([^&]*)').exec(url);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getParams() {
  var query = window.location.search;

  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {}) : false;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function superscript() {
  jQuery(function ($) {
    $('p,h1,h2,h3,h4,h5,h6,li,a,span,td,th,i,b,u,em,strong,del,label,small').contents().filter(function () {
      return this.nodeType === 3;
    }).replaceWith(function () {
      return this.nodeValue.replace(/[®™️]/g, '<sup>$&</sup>');
    });
  });
}

function urlDecode(str) {
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}

/*
==========================================================================
class utility
==========================================================================
*/

var RezberryClass = function () {
  _createClass(RezberryClass, [{
    key: 'addListeners',


    /*
    ==========================================================================
    listeners
    ==========================================================================
    */
    value: function addListeners() {
      for (var selector in this.listeners) {
        this.addListener(selector, this.listeners[selector]);
      }
    }
  }, {
    key: 'addListener',
    value: function addListener(selector, listener) {
      if (listener instanceof Array) {
        for (var item in listener) {
          if (!listener.hasOwnProperty(item)) continue;
          this.addListener(selector, listener[item]);
        }
      } else {
        this[selector].on(listener.ev, this[listener.func].bind(this));
      }
    }

    /*
    ==========================================================================
    selectors
    ==========================================================================
    */

  }, {
    key: 'addSelectors',
    value: function addSelectors() {
      for (var name in this.selectors) {
        this.addSelector(name, this.selectors[name]);
      }
    }
  }, {
    key: 'addSelector',
    value: function addSelector(name, selector) {
      this['$' + name] = this.$scope.find(selector);
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }]);

  function RezberryClass(scope) {
    _classCallCheck(this, RezberryClass);

    this.$scope = jQuery(scope);
  }

  return RezberryClass;
}();

/*
==========================================================================
export
==========================================================================
*/


exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.getParam = getParam;
exports.getParams = getParams;
exports.debounce = debounce;
exports.superscript = superscript;
exports.urlDecode = urlDecode;
exports.RezberryClass = RezberryClass;

},{}],3:[function(require,module,exports){
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var Tooltip = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'tooltip';
  var VERSION = '4.0.0';
  var DATA_KEY = 'bs.tooltip';
  var EVENT_KEY = "." + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;
  var CLASS_PREFIX = 'bs-tooltip';
  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
  var DefaultType = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: '(number|string)',
    container: '(string|element|boolean)',
    fallbackPlacement: '(string|array)',
    boundary: '(string|element)'
  };
  var AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var Default = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: 0,
    container: false,
    fallbackPlacement: 'flip',
    boundary: 'scrollParent'
  };
  var HoverState = {
    SHOW: 'show',
    OUT: 'out'
  };
  var Event = {
    HIDE: "hide" + EVENT_KEY,
    HIDDEN: "hidden" + EVENT_KEY,
    SHOW: "show" + EVENT_KEY,
    SHOWN: "shown" + EVENT_KEY,
    INSERTED: "inserted" + EVENT_KEY,
    CLICK: "click" + EVENT_KEY,
    FOCUSIN: "focusin" + EVENT_KEY,
    FOCUSOUT: "focusout" + EVENT_KEY,
    MOUSEENTER: "mouseenter" + EVENT_KEY,
    MOUSELEAVE: "mouseleave" + EVENT_KEY
  };
  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector = {
    TOOLTIP: '.tooltip',
    TOOLTIP_INNER: '.tooltip-inner',
    ARROW: '.arrow'
  };
  var Trigger = {
    HOVER: 'hover',
    FOCUS: 'focus',
    CLICK: 'click',
    MANUAL: 'manual'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Tooltip =
  /*#__PURE__*/
  function () {
    function Tooltip(element, config) {
      /**
       * Check for Popper dependency
       * Popper - https://popper.js.org
       */
      if (typeof Popper === 'undefined') {
        throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
      } // private


      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._popper = null; // Protected

      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    } // Getters


    var _proto = Tooltip.prototype;

    // Public
    _proto.enable = function enable() {
      this._isEnabled = true;
    };

    _proto.disable = function disable() {
      this._isEnabled = false;
    };

    _proto.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    _proto.toggle = function toggle(event) {
      if (!this._isEnabled) {
        return;
      }

      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $(event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {
        if ($(this.getTipElement()).hasClass(ClassName.SHOW)) {
          this._leave(null, this);

          return;
        }

        this._enter(null, this);
      }
    };

    _proto.dispose = function dispose() {
      clearTimeout(this._timeout);
      $.removeData(this.element, this.constructor.DATA_KEY);
      $(this.element).off(this.constructor.EVENT_KEY);
      $(this.element).closest('.modal').off('hide.bs.modal');

      if (this.tip) {
        $(this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;

      if (this._popper !== null) {
        this._popper.destroy();
      }

      this._popper = null;
      this.element = null;
      this.config = null;
      this.tip = null;
    };

    _proto.show = function show() {
      var _this = this;

      if ($(this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $.Event(this.constructor.Event.SHOW);

      if (this.isWithContent() && this._isEnabled) {
        $(this.element).trigger(showEvent);
        var isInTheDom = $.contains(this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);
        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);
        this.setContent();

        if (this.config.animation) {
          $(tip).addClass(ClassName.FADE);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        this.addAttachmentClass(attachment);
        var container = this.config.container === false ? document.body : $(this.config.container);
        $(tip).data(this.constructor.DATA_KEY, this);

        if (!$.contains(this.element.ownerDocument.documentElement, this.tip)) {
          $(tip).appendTo(container);
        }

        $(this.element).trigger(this.constructor.Event.INSERTED);
        this._popper = new Popper(this.element, tip, {
          placement: attachment,
          modifiers: {
            offset: {
              offset: this.config.offset
            },
            flip: {
              behavior: this.config.fallbackPlacement
            },
            arrow: {
              element: Selector.ARROW
            },
            preventOverflow: {
              boundariesElement: this.config.boundary
            }
          },
          onCreate: function onCreate(data) {
            if (data.originalPlacement !== data.placement) {
              _this._handlePopperPlacementChange(data);
            }
          },
          onUpdate: function onUpdate(data) {
            _this._handlePopperPlacementChange(data);
          }
        });
        $(tip).addClass(ClassName.SHOW); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

        if ('ontouchstart' in document.documentElement) {
          $('body').children().on('mouseover', null, $.noop);
        }

        var complete = function complete() {
          if (_this.config.animation) {
            _this._fixTransition();
          }

          var prevHoverState = _this._hoverState;
          _this._hoverState = null;
          $(_this.element).trigger(_this.constructor.Event.SHOWN);

          if (prevHoverState === HoverState.OUT) {
            _this._leave(null, _this);
          }
        };

        if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
          $(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
        } else {
          complete();
        }
      }
    };

    _proto.hide = function hide(callback) {
      var _this2 = this;

      var tip = this.getTipElement();
      var hideEvent = $.Event(this.constructor.Event.HIDE);

      var complete = function complete() {
        if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this2._cleanTipClass();

        _this2.element.removeAttribute('aria-describedby');

        $(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

        if (_this2._popper !== null) {
          _this2._popper.destroy();
        }

        if (callback) {
          callback();
        }
      };

      $(this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $(tip).removeClass(ClassName.SHOW); // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support

      if ('ontouchstart' in document.documentElement) {
        $('body').children().off('mouseover', null, $.noop);
      }

      this._activeTrigger[Trigger.CLICK] = false;
      this._activeTrigger[Trigger.FOCUS] = false;
      this._activeTrigger[Trigger.HOVER] = false;

      if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
        $(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    _proto.update = function update() {
      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    }; // Protected


    _proto.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $(this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var $tip = $(this.getTipElement());
      this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());
      $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
    };

    _proto.setElementContent = function setElementContent($element, content) {
      var html = this.config.html;

      if (typeof content === 'object' && (content.nodeType || content.jquery)) {
        // Content is a DOM node or a jQuery
        if (html) {
          if (!$(content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($(content).text());
        }
      } else {
        $element[html ? 'html' : 'text'](content);
      }
    };

    _proto.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    }; // Private


    _proto._getAttachment = function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    };

    _proto._setListeners = function _setListeners() {
      var _this3 = this;

      var triggers = this.config.trigger.split(' ');
      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function (event) {
            return _this3.toggle(event);
          });
        } else if (trigger !== Trigger.MANUAL) {
          var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
          var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
          $(_this3.element).on(eventIn, _this3.config.selector, function (event) {
            return _this3._enter(event);
          }).on(eventOut, _this3.config.selector, function (event) {
            return _this3._leave(event);
          });
        }

        $(_this3.element).closest('.modal').on('hide.bs.modal', function () {
          return _this3.hide();
        });
      });

      if (this.config.selector) {
        this.config = _extends({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    _proto._fixTitle = function _fixTitle() {
      var titleType = typeof this.element.getAttribute('data-original-title');

      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    _proto._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
      }

      if ($(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
        context._hoverState = HoverState.SHOW;
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HoverState.SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    _proto._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HoverState.OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, this.constructor.Default, $(this.element).data(), config);

      if (typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      if (typeof config.title === 'number') {
        config.title = config.title.toString();
      }

      if (typeof config.content === 'number') {
        config.content = config.content.toString();
      }

      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
      return config;
    };

    _proto._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $(this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

      if (tabClass !== null && tabClass.length > 0) {
        $tip.removeClass(tabClass.join(''));
      }
    };

    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(data) {
      this._cleanTipClass();

      this.addAttachmentClass(this._getAttachment(data.placement));
    };

    _proto._fixTransition = function _fixTransition() {
      var tip = this.getTipElement();
      var initConfigAnimation = this.config.animation;

      if (tip.getAttribute('x-placement') !== null) {
        return;
      }

      $(tip).removeClass(ClassName.FADE);
      this.config.animation = false;
      this.hide();
      this.show();
      this.config.animation = initConfigAnimation;
    }; // Static


    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        var _config = typeof config === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType;
      }
    }]);

    return Tooltip;
  }();
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */


  $.fn[NAME] = Tooltip._jQueryInterface;
  $.fn[NAME].Constructor = Tooltip;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tooltip._jQueryInterface;
  };

  return Tooltip;
}($, Popper);

},{}],4:[function(require,module,exports){
/*! npm.im/object-fit-images 3.2.4 */
'use strict';

var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;

},{}],5:[function(require,module,exports){
'use strict';

require('./molecules/carousel/carousel');

require('./molecules/filter/filter');

require('./molecules/filters/filters');

require('./molecules/form/form');

require('./molecules/loading/loading');

require('./molecules/owl-carousel/owl-carousel');

require('./molecules/popup-gallery/popup-gallery');

require('./molecules/popup-iframe/popup-iframe');

require('./molecules/overlap/overlap');

require('./molecules/slick/slick');

require('./molecules/search-form/search-form');

require('./molecules/video/video');

require('./molecules/view-more/view-more');

require('./organisms/alert/alert');

require('./organisms/footer-back-to-top/footer-back-to-top');

require('./organisms/footer-cookies/footer-cookies');

require('./organisms/tenant-nav/tenant-nav');

require('./organisms/01-hero/01-hero');

require('./organisms/09-text-image-bg-sticky/09-text-image-bg-sticky');

require('./organisms/03b-billboard/03b-billboard');

require('./organisms/07-full-width-media/07-full-width-media');

require('./organisms/10b-two-col-text-media/10b-two-col-text-media');

require('./organisms/10c-two-col-text-media/10c-two-col-text-media');

require('./organisms/11-brackets/11-brackets');

require('./organisms/12-logos/12-logos');

$(window).on('orientationchange resize scroll', function () {
  cardAnimate();
  //photoBgSize() <-- console log says undefined
  entrances();
}); /* Check same file in parent theme for examples. */

$(window).on('load', function () {
  cardAnimate();
  //photoBgSize() <-- console log says undefined

  setTimeout(function () {
    $('.pre-render').removeClass('pre-render');
    $('.m-page-intro-img').addClass('in');
    $('.delay-animation').removeClass('delay-animation').addClass('in');
  }, 200);

  $('.vimeo-video iframe').addClass('vimeo-vid');
});

$(document).on('ready', function () {
  $('.vimeo-video iframe').addClass('vimeo-vid');
});

setTimeout(function () {
  $('.pre-render').removeClass('pre-render');
  $('.m-page-intro-header h1, .m-page-intro-content, .m-page-intro-img, .hero-fade, .hero-fade-delay, .hero-fade-slideup, .hero-title-gradient').addClass('in');
  $('.delay-animation').removeClass('delay-animation').addClass('in');
}, 200);

$(function () {

  setTimeout(function () {
    $('.pre-render').removeClass('pre-render');
    $('.m-page-intro-header h1, .m-page-intro-content, .hero-fade, .hero-fade-delay, .hero-fade-slideup, .hero-title-gradient').addClass('in');
  }, 200);

  entrances();
});

function entrances() {

  var scrollTop = $(window).scrollTop();
  var windowBottom = scrollTop + $(window).height();
  windowBottom = windowBottom - 100;

  $('.fade:not(.delay-animation), .fade-slideup:not(.delay-animation), .stagger-animation:not(.delay-animation), .slideleft:not(.delay-animation), .slideup:not(.delay-animation), .slideright:not(.delay-animation), .rotate-y:not(.delay-animation), .rotate-y-front:not(.delay-animation)').each(function () {
    var objectTop = $(this).offset().top;
    if (objectTop < windowBottom) {
      $(this).addClass('in');
      if ($(this).hasClass('slideleft')) {
        $(this).parents('.slideleft-wrapper').addClass('in');
      } else if ($(this).hasClass('stagger-animation')) {
        $(this).find('.stagger-item:not(.card, .card-stagger-item, .content-grid-item, .bracket-stagger-item)').addClass('in');
      }
    } else {
      if ($(this).hasClass('in')) {
        $(this).removeClass('in');
        if ($(this).hasClass('slideleft')) {
          $(this).parents('.slideleft-wrapper').removeClass('in');
        } else if ($(this).hasClass('stagger-animation')) {
          $(this).find('.stagger-item:not(.card, .card-stagger-item, .content-grid-item, .bracket-stagger-item)').removeClass('in');
        }
      }
    }
  });

  $('.card-flip').each(function () {
    var objectTop = $(this).offset().top;
    if (objectTop < windowBottom) {
      $(this).addClass('flipped-front');
    } else {
      if ($(this).hasClass('flipped-front')) {
        $(this).removeClass('flipped-front');
      }
    }
  });

  $('.gradient-border').each(function () {
    var borderTop = $(this).offset().top;
    if ($(this).hasClass('hero-border') && $(this).parents('.hero').hasClass('hero-feature')) {
      windowBottom = windowBottom + 100;
    } else {
      windowBottom = windowBottom;
    }
    // windowBottom = windowBottom + 100
    if (borderTop < windowBottom) {
      $(this).addClass('in');
    } else {
      if ($(this).hasClass('in')) {
        $(this).removeClass('in');
      }
    }
  });

  if ($(this).hasClass('card')) {
    var elBottom = $(this).offset().top + $(this).innerHeight();
    if (scrollTop >= elBottom - window.innerHeight) {
      $(this).addClass('in');
    }
  }
}

function triggerCardAnimateTop(el, triggerPoint, top) {
  if (top >= triggerPoint - window.innerHeight) {
    $(el).addClass('in');
  } else {
    $(el).removeClass('in');
  }
}
function triggerCardAnimateBottom(el, triggerPoint, bottom) {
  if (triggerPoint < bottom) {
    $(el).addClass('in');
  } else {
    $(el).removeClass('in');
  }
}

function cardAnimate() {

  var scrollTop = $(window).scrollTop();
  var windowBottom = scrollTop + $(window).height();
  var breakpoint = 768;

  $('.card.stagger-item, .card-stagger-item.stagger-item, .content-grid-item.stagger-item, .bracket-stagger-item.stagger-item').each(function () {
    if ($(this).parents('.stagger-animation').hasClass('service-feature-list-cards')) {
      breakpoint = 1260;
    }
    var trigger;
    if ($(window).innerWidth() < breakpoint) {
      if ($(this).prev().hasClass('in')) {
        trigger = $(this).prev().offset().top + $(this).prev().innerHeight();
        trigger + 20;
        triggerCardAnimateTop($(this), trigger, scrollTop);
      } else {
        trigger = $(this).offset().top;
        triggerCardAnimateBottom($(this), trigger, windowBottom);
      }
    } else {
      if (($(this).hasClass('three-col') || $(this).hasClass('col-lg-4')) && $(window).width() >= 992) {
        trigger = $(this).offset().top;
        triggerCardAnimateBottom($(this), trigger, windowBottom);
      } else {

        if ($(this).is(':nth-of-type(odd):not(.card-more-link)')) {
          $(this).addClass('odd-first');
          trigger = $(this).offset().top;
          triggerCardAnimateBottom($(this), trigger, windowBottom);
        } else {
          $(this).addClass('even');
          trigger = $(this).offset().top;
          triggerCardAnimateBottom($(this), trigger, windowBottom);
        }
      }
    }
  });
}

/*------------------------------------
 Background Pattern Things
--------------------------------------*/
$('.with-pattern').each(function () {
  var $patternElement = $(this).find('.bg-geo-pattern'),
      $prevMod = $(this).prev('section'),
      $nextMod = $(this).next('section'),
      prevModOuterHeight = $prevMod.outerHeight(),
      prevModInnerHeight = $prevMod.height(),
      prevModBottomPad;

  if ($prevMod.not('.with-pattern')) {
    $prevMod.addClass('ontop-of-pattern');
  } else {
    if ($prevMod.not('.never-pattern')) {
      $prevMod.addClass('ontop-of-pattern');
    }
  }

  // if( $nextMod.not('.with-pattern') ) {
  //   $nextModMod.addClass('ontop-of-pattern')
  // }

  if ($patternElement.parents('section').is('.m-testimonial.with-pattern')) {
    $prevMod.css('z-index', '4').addClass('before-testimonial');
  }

  if ($nextMod.is('.m-billboard-lg')) {
    $nextMod.addClass('extra-z');
  }

  if ($prevMod.is('.m-billboard-lg')) {
    // $patternElement.addClass('bg-modify-top')
    $patternElement.addClass('bg-top-0');
  }

  //     console.log('outer:' + prevModOuterHeight + ' inner:' + prevModInnerHeight)

  // if( ($prevMod.is('.pt-0') || $prevMod.is('.pb-0')) && !$prevMod.is('.pt-0 .pb-0') ) {
  //   prevModBottomPad = (prevModOuterHeight - prevModInnerHeight) * -1
  // }
  // else {
  //   prevModBottomPad = (prevModOuterHeight - prevModInnerHeight) / -2
  // }
  // prevModBottomPad = prevModBottomPad - 20

  // $patternElement.css('top', prevModBottomPad+'px')

  $('.bg-video-actions button').on('click', function (e) {
    $(this).toggleClass('paused');
    e.preventDefault();
    var videoItem;

    var $iframeWrapper = $(this).parents('section').find('.iframe-wrapper'),
        iframe = $iframeWrapper.find('iframe');

    if (iframe) {
      videoItem = new Vimeo.Player(iframe);

      // vimeo player specific functions
      videoItem.getPaused().then(function (paused) {
        // paused = whether or not the player is paused
        if (paused) {
          videoItem.play();
        } else {
          videoItem.pause();
        }
      }).catch(function (error) {
        // an error occurred
      });
    }
  });
});

},{"./molecules/carousel/carousel":6,"./molecules/filter/filter":7,"./molecules/filters/filters":8,"./molecules/form/form":9,"./molecules/loading/loading":10,"./molecules/overlap/overlap":11,"./molecules/owl-carousel/owl-carousel":12,"./molecules/popup-gallery/popup-gallery":13,"./molecules/popup-iframe/popup-iframe":14,"./molecules/search-form/search-form":15,"./molecules/slick/slick":16,"./molecules/video/video":17,"./molecules/view-more/view-more":18,"./organisms/01-hero/01-hero":19,"./organisms/03b-billboard/03b-billboard":20,"./organisms/07-full-width-media/07-full-width-media":21,"./organisms/09-text-image-bg-sticky/09-text-image-bg-sticky":22,"./organisms/10b-two-col-text-media/10b-two-col-text-media":23,"./organisms/10c-two-col-text-media/10c-two-col-text-media":24,"./organisms/11-brackets/11-brackets":25,"./organisms/12-logos/12-logos":26,"./organisms/alert/alert":27,"./organisms/footer-back-to-top/footer-back-to-top":28,"./organisms/footer-cookies/footer-cookies":29,"./organisms/tenant-nav/tenant-nav":30}],6:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(window).on('resize orientationchange', function () {
    if ($(window).innerWidth() < 768) {
      $('.carousel-wrapper').each(function () {
        $(this).find('.carousel-mobile.slick-initialized').slick('resize');
      });
    }
    slickMe();
    carouselHeight();
  });

  $(document).ready(function () {
    $('.carousel-wrapper').each(function (i) {
      $(this).attr('id', 'carousel-' + i);
    });
    slickMe();
  });

  $(window).on('load', function () {
    carouselHeight();
  });

  $('.carousel-img').click(function () {
    var parent = $(this).parents('.carousel-wrapper');
    moveToSelected($(this), parent);
  });

  $('.nav-prev').click(function () {
    var parent = $(this).parents('.carousel-wrapper');
    moveToSelected('img-prev', parent);
  });

  $('.nav-next').click(function () {
    var parent = $(this).parents('.carousel-wrapper');
    moveToSelected('img-next', parent);
  });

  function carouselHeight() {
    $('.carousel-wrapper').each(function () {
      var carouselItems = $(this).find('.carousel-img'),
          tallestImg = 0;
      carouselItems.map(function () {
        var imgHeight = $(this).height();
        if (imgHeight > tallestImg) {
          tallestImg = imgHeight;
        }
      });
      if (window.innerWidth >= 768) {
        $(this).height(tallestImg + 50);
      } else {
        $(this).height('initial');
      }
    });
  }

  function moveToSelected(element, parent) {
    var $activeImg, $nextImg, $prevImg, $nextNextImg, $prevPrevImg;

    if (element == "img-next" || element == 'img-prev' || element.hasClass('img-next') || element.hasClass('img-prev')) {
      $activeImg = parent.find('.img-active');
      $nextImg = parent.find('.img-next');
      $prevImg = parent.find('.img-prev');
      $nextNextImg = parent.find('.img-next-next');
      $prevPrevImg = parent.find('.img-prev-prev');
    } else if (element == "img-prev") {
      var activeImg = parent.find(".img-active").prev();
    } else {
      if (element.hasClass('img-next-next')) {
        moveToSelected('img-next', parent);
        moveToSelected('img-next', parent);
      }
      if (element.hasClass('img-prev-prev')) {
        moveToSelected('img-prev', parent);
        moveToSelected('img-prev', parent);
      }
    }

    if (element == 'img-next') {
      $activeImg.removeClass('img-active').addClass('img-prev');
      $nextImg.removeClass('img-next').addClass('img-active');
      $nextNextImg.removeClass('img-next-next').addClass('img-next');
      $nextNextImg.next().removeClass('img-next-hidden').addClass('img-next-next');
      $prevImg.removeClass('img-prev').addClass('img-prev-prev');
      $prevPrevImg.removeClass('img-prev-prev').addClass('img-next-hidden');

      if (parent.is('.carousel-infinite')) {
        if ($nextNextImg.is('.carousel-img:last-of-type')) {
          parent.find('.carousel-img:first-of-type').removeClass('img-next-hidden').addClass('img-next-next');
        }
      } else {
        if ($nextImg.is('.carousel-img:last-of-type')) {
          parent.find('.nav-next').addClass('disabled');
        }
        parent.find('.nav-prev').removeClass('disabled');
      }
    } else if (element == 'img-prev') {
      $activeImg.removeClass('img-active').addClass('img-next');
      $prevImg.removeClass('img-prev').addClass('img-active');
      $prevPrevImg.prev().removeClass('img-next-hidden').addClass('img-prev-prev');
      $prevPrevImg.removeClass('img-prev-prev').addClass('img-prev');
      $nextImg.removeClass('img-next').addClass('img-next-next');
      $nextNextImg.removeClass('img-next-next').addClass('img-next-hidden');

      if (parent.is('.carousel-infinite')) {
        if ($nextNextImg.is('.carousel-img:first-of-type')) {
          parent.find('.carousel-img:first-of-type').removeClass('img-next-next').addClass('img-next-hidden');
        }
        if ($prevPrevImg.is('.carousel-img:first-of-type')) {
          parent.find('.carousel-img:last-of-type').removeClass('img-next-hidden').addClass('img-prev-prev');
        }
      } else {
        if ($prevImg.is('.carousel-img:first-of-type')) {
          parent.find('.nav-prev').addClass('disabled');
        }
        parent.find('.nav-next').removeClass('disabled');
      }
    } else {
      if (element.hasClass('img-next')) {
        moveToSelected('img-next', parent);
      }
      if (element.hasClass('img-prev')) {
        moveToSelected('img-prev', parent);
      }
    }
  }

  function slickMe() {
    if ($(window).innerWidth() < 768) {
      $('.carousel-mobile:not(.slick-initialized)').each(function () {
        var infinite = $(this).data('infinite'),
            autoplay = $(this).data('autoplay');

        $(this).slick({
          adaptiveHeight: false,
          arrows: true,
          autoplay: autoplay,
          dots: false,
          fade: true,
          infinite: infinite,
          mobileFirst: true,
          rows: 0,
          slidesToScroll: 1,
          slidesToShow: 1,
          initialSlide: 0,
          centerMode: true,
          centerPadding: '40px',
          cssEase: 'ease-in',
          responsive: [{
            breakpoint: 567,
            settings: {
              dots: false,
              arrows: true,
              centerPadding: '80px'
            }
          }]
        });
      });
    } else {
      $('.carousel-mobile.slick-initialized').slick('unslick');
    }
  }
});

},{}],7:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

jQuery(function ($) {
  $(document).ready(function () {
    $(document).on('click', '.js-filter-value', function (e) {
      e.preventDefault();

      var $this = $(this),
          $filterWrapper = $this.parents('.js-filter-values').first(),
          endpoint = $filterWrapper.data('endpoint'),
          exclusive = $filterWrapper.data('exclusive'),
          $wrapper = $this.parents('[rez-app]');

      $filterWrapper.find('.js-filter-value').removeClass('is-active');

      if (exclusive) {
        var $otherWrappers = $wrapper.find('.js-filter-values').not($filterWrapper),
            $otherValues = $otherWrappers.find('.js-filter-value');
        $otherValues.removeClass('is-active');
        $otherValues.filter('[data-value="any"]').addClass('is-active');
      }

      $this.addClass('is-active');

      var $active = $wrapper.find('.js-filter-value.is-active').filter(':visible'),
          fields = [],
          operators = [],
          values = [],
          text = '';

      $active.each(function (index, item) {
        var $item = $(item),
            trimmed = $.trim($item.text());

        fields.push($item.data('field'));
        operators.push($item.data('operator') ? $item.data('operator') : 'equal');
        values.push($item.data('value'));

        $wrapper.find('.filter-indicator-' + (index + 1)).text(trimmed);

        if ($item.data('value') != 'any') {
          var newText = $item.data('label') + trimmed;
          text += !text.length ? newText : ', ' + newText;
        }
      });

      if (!text.length) text = 'Everything';
      $('.filters-desktop .filters-indicator').text(text);

      $('.filters-mobile .filters-group').collapse('hide');

      $('.loading').show();
      $.ajax({
        type: 'GET',
        url: endpoint,
        data: {
          fields: fields,
          operators: operators,
          values: values
        },
        success: function success(res) {
          $wrapper.find('.js-filters-stage').first().html(res);
          (0, _utilities.superscript)();
          $('.loading').hide();
        }
      });
    });

    var $active = $('.js-filter-value.is-active').filter(':visible');
    if ($active.length) {
      $active.each(function (index, item) {
        var $item = $(item);
        if ($item.data('value') != 'any') $item.trigger('click');
      });
    }
  });
});

},{"../../../assets/src/js/utilities":2}],8:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.filters-mobile .filters-group').on('show.bs.collapse', function () {
      $(this).parents('.filters-mobile').addClass('is-active');
    });
    $('.filters-mobile .filters-group').on('hidden.bs.collapse', function () {
      $(this).parents('.filters-mobile').removeClass('is-active');
    });
  });
});

},{}],9:[function(require,module,exports){
'use strict';

/*------------------------------------
  Form Functions
--------------------------------------*/
var inputs = '.hbspt-form input:not([type="radio"]):not([type="checkbox"]):not([type="submit"]):not([type="button"]):not([type="image"]):not([type="file"]):visible, .hbspt-form textarea:visible, .hbspt-form select';

$(window).on('load', function () {
  $('.hbspt-form .hs-form-field').each(function () {
    if ($(this).find('.hs-form-required').length > 0) {
      $(this).addClass('required');
    }
  });
  $(inputs).each(function () {
    if ($(this).val() !== '') {
      $(this).parents('.hs-form-field').find('label:first').addClass('in-focus');

      if ($(this).parents('.hs-form-field').find('.hs-error-msgs:visible')) {
        $(this).parents('.hs-form-field').addClass('invalid');
        $(this).parents('.form-columns-2').addClass('invalid-extra-space');
      }
    }
  });
  // $('.hbspt-form .hs-form textarea').each(function() {
  //   var offset = $(this).offsetHeight - $(this).clientHeight
  //   $(this).addClass('hello')
  //   console.log(offset)

  //   var resizeArea = function(el) {
  //     $(el).css('height', '50px').css('height', el.scrollHeight + offset)
  //     $(el).parents('.hs-fieldtype-textarea').css('height', el.scrollHeight + offset)
  //     $(el).parents('fieldset').css('height', el.scrollHeight + offset)
  //   }

  //   $(this).on('keyup input', function() {
  //     console.log(offset)
  //     resizeArea($(this))
  //   })
  // })
});

$('.hbspt-form select').on('change', function () {
  if ($(this).find('option:selected').val() != '') {
    $(this).removeClass('holding');
  } else {
    $(this).parents('.hs-form-field').find('label:first').removeClass('in-focus');
  }
});

$(document).on('focus', inputs, function () {
  $(this).parents('.hs-form-field').find('.input').addClass('in-focus');
  $(this).parents('.hs-form-field').find('label:first').addClass('in-focus azure');
});

$(document).on('blur', inputs, function () {
  $(this).parents('.hs-form-field').find('.input').removeClass('in-focus');
  $(this).parents('.hs-form-field').find('label:first').removeClass('in-focus azure');

  if ($(this).val().length > 0) {
    $(this).parents('.hs-form-field').find('label:first').addClass('in-focus');

    if ($(this).hasClass('invalid') || $(this).parents('.hs-form-field').find('.hs-error-msgs:visible')) {
      $(this).parents('.hs-form-field').find('label:first').addClass('invalid');
      $(this).parents('.hs-form-field').addClass('invalid');
    } else {
      $(this).parents('.hs-form-field').find('label:first').removeClass('invalid');
      $(this).parents('.hs-form-field').removeClass('invalid');
    }
  } else {
    $(this).parents('.hs-form-field').find('label:first').removeClass('in-focus');
    if ($(this).parents('.hs-form-field').hasClass('required')) {
      $(this).parents('.hs-form-field').addClass('invalid');
      $(this).parents('.hs-form-field').find('label:first').addClass('invalid');
    }
  }
});

$(window).on('load', function () {
  setTimeout(function () {
    $('textarea').each(function () {
      var offset = this.offsetHeight - this.clientHeight;

      var resizeArea = function resizeArea(el) {
        var newHeight = el.scrollHeight + offset + 20;
        $(el).css('height', '50px').css('height', el.scrollHeight + offset);
        $(el).parents('.hs-fieldtype-textarea').css('height', el.scrollHeight + offset + 22);
      };

      $(this).on('keyup input', function () {
        resizeArea(this);
      });
    });
  }, 500);
});

},{}],10:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.loading:not(:first)').remove();
  });
});

},{}],11:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(document).ready(function () {
    // invadedPadding()
  });

  $(window).on('resize, orientationChange', function () {
    // invadedPadding()
  });

  $('.rez-overlap').each(function () {
    var $section;

    if ($(this).is('section')) {
      $section = $(this);
    } else {
      $section = $(this).parents('section');
    }

    var $prevSection = $section.prev('section').not('.m-subnav');

    $prevSection.addClass('rez-space-invaded');

    $prevSection.each(function () {
      var $pbSection = $(this).filter(function () {
        return this.className.match(/\bpb/);
      }),
          pb;

      $pbSection.filter(function () {
        var classes = $(this).attr('class').split(" ");
        for (var i = 0; i < classes.length; i++) {
          if (classes[i].match('^pb')) {
            pb = classes[i];
          }
        }
      });

      $(this).removeClass(pb);
    });
  });

  function invadedPadding() {
    $('.rez-space-invaded').each(function () {
      var ih = $(this).height(),
          oh = $(this).outerHeight(),
          padding;

      console.log('outer:' + oh + '     inner:' + ih);

      if (ih == oh) {
        $(this).css('height', 'auto').css('height', oh + 100);
      } else {
        padding = (oh - ih) / 2;
        // console.log(pb)
        $(this).css('padding-bottom', padding + 100);
      }
    });
  }
});

},{}],12:[function(require,module,exports){
'use strict';

// $(document).ready(function () {
//   var owl = $('.owl-carousel');
//   owl.owlCarousel({
//       items: 5,
//       loop: true,
//       margin: 20,
//       autoplay: true,
//       autoWidth: true,
//       slideTransition: 'linear',
//       // slideTransition: 'cubic-bezier',
//       autoplayTimeout: 2500,
//       autoplaySpeed: 2500,
//       autoplayHoverPause: true,
//       dots: false,

//   });

// });
//Alternate Direction
// $(document).ready(function () {
//   var owl = $('.owl-carousel2');
//   owl.owlCarousel({
//       items: 8,
//       rtl: true,
//       loop: true,
//       margin: 20,
//       autoplay: true,
//       slideTransition: 'linear',
//       autoplayTimeout: 0,
//       autoplaySpeed: 3000,
//       autoplayHoverPause: false

//   });

// });

//*******************************************
//***CODE BELOW===> This is a custom owl carousel js, you can add it by pasting the code below into a js file and use it in your website.

/**
* Owl carousel
* @version 2.0.0
* @author Bartosz Wojciechowski
* @license The MIT License (MIT)
* @todo Lazy Load Icon
* @todo prevent animationend bubling
* @todo itemsScaleUp
* @todo Test Zepto
* @todo stagePadding calculate wrong active classes
*/
;(function ($, window, document, undefined) {

  var drag, state, e;

  /**
   * Template for status information about drag and touch events.
   * @private
   */
  drag = {
    start: 0,
    startX: 0,
    startY: 0,
    current: 0,
    currentX: 0,
    currentY: 0,
    offsetX: 0,
    offsetY: 0,
    distance: null,
    startTime: 0,
    endTime: 0,
    updatedX: 0,
    targetEl: null
  };

  /**
   * Template for some status informations.
   * @private
   */
  state = {
    isTouch: false,
    isScrolling: false,
    isSwiping: false,
    direction: false,
    inMotion: false
  };

  /**
   * Event functions references.
   * @private
   */
  e = {
    _onDragStart: null,
    _onDragMove: null,
    _onDragEnd: null,
    _transitionEnd: null,
    _resizer: null,
    _responsiveCall: null,
    _goToLoop: null,
    _checkVisibile: null
  };

  /**
   * Creates a carousel.
   * @class The Owl Carousel.
   * @public
   * @param {HTMLElement|jQuery} element - The element to create the carousel for.
   * @param {Object} [options] - The options
   */
  function Owl(element, options) {

    /**
     * Current settings for the carousel.
     * @public
     */
    this.settings = null;

    /**
     * Current options set by the caller including defaults.
     * @public
     */
    this.options = $.extend({}, Owl.Defaults, options);

    /**
     * Plugin element.
     * @public
     */
    this.$element = $(element);

    /**
     * Caches informations about drag and touch events.
     */
    this.drag = $.extend({}, drag);

    /**
     * Caches some status informations.
     * @protected
     */
    this.state = $.extend({}, state);

    /**
     * @protected
     * @todo Must be documented
     */
    this.e = $.extend({}, e);

    /**
     * References to the running plugins of this carousel.
     * @protected
     */
    this._plugins = {};

    /**
     * Currently suppressed events to prevent them from beeing retriggered.
     * @protected
     */
    this._supress = {};

    /**
     * Absolute current position.
     * @protected
     */
    this._current = null;

    /**
     * Animation speed in milliseconds.
     * @protected
     */
    this._speed = null;

    /**
     * Coordinates of all items in pixel.
     * @todo The name of this member is missleading.
     * @protected
     */
    this._coordinates = [];

    /**
     * Current breakpoint.
     * @todo Real media queries would be nice.
     * @protected
     */
    this._breakpoint = null;

    /**
     * Current width of the plugin element.
     */
    this._width = null;

    /**
     * All real items.
     * @protected
     */
    this._items = [];

    /**
     * All cloned items.
     * @protected
     */
    this._clones = [];

    /**
     * Merge values of all items.
     * @todo Maybe this could be part of a plugin.
     * @protected
     */
    this._mergers = [];

    /**
     * Invalidated parts within the update process.
     * @protected
     */
    this._invalidated = {};

    /**
     * Ordered list of workers for the update process.
     * @protected
     */
    this._pipe = [];

    $.each(Owl.Plugins, $.proxy(function (key, plugin) {
      this._plugins[key[0].toLowerCase() + key.slice(1)] = new plugin(this);
    }, this));

    $.each(Owl.Pipe, $.proxy(function (priority, worker) {
      this._pipe.push({
        'filter': worker.filter,
        'run': $.proxy(worker.run, this)
      });
    }, this));

    this.setup();
    this.initialize();
  }

  /**
   * Default options for the carousel.
   * @public
   */
  Owl.Defaults = {
    items: 3,
    loop: false,
    center: false,
    slideTransition: '',

    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    freeDrag: false,

    margin: 0,
    stagePadding: 0,

    merge: false,
    mergeFit: true,
    autoWidth: false,

    startPosition: 0,
    rtl: false,

    smartSpeed: 250,
    fluidSpeed: false,
    dragEndSpeed: false,

    responsive: {},
    responsiveRefreshRate: 200,
    responsiveBaseElement: window,
    responsiveClass: false,

    fallbackEasing: 'swing',

    info: false,

    nestedItemSelector: false,
    itemElement: 'div',
    stageElement: 'div',

    // Classes and Names
    themeClass: 'owl-theme',
    baseClass: 'owl-carousel',
    itemClass: 'owl-item',
    centerClass: 'center',
    activeClass: 'active'

  };

  /**
   * Enumeration for width.
   * @public
   * @readonly
   * @enum {String}
   */
  Owl.Width = {
    Default: 'default',
    Inner: 'inner',
    Outer: 'outer'
  };

  /**
   * Contains all registered plugins.
   * @public
   */
  Owl.Plugins = {};

  /**
   * Update pipe.
   */
  Owl.Pipe = [{
    filter: ['width', 'items', 'settings'],
    run: function run(cache) {
      cache.current = this._items && this._items[this.relative(this._current)];
    }
  }, {
    filter: ['items', 'settings'],
    run: function run() {
      var cached = this._clones,
          clones = this.$stage.children('.cloned');

      if (clones.length !== cached.length || !this.settings.loop && cached.length > 0) {
        this.$stage.children('.cloned').remove();
        this._clones = [];
      }
    }
  }, {
    filter: ['items', 'settings'],
    run: function run() {
      var i,
          n,
          clones = this._clones,
          items = this._items,
          delta = this.settings.loop ? clones.length - Math.max(this.settings.items * 2, 4) : 0;

      for (i = 0, n = Math.abs(delta / 2); i < n; i++) {
        if (delta > 0) {
          this.$stage.children().eq(items.length + clones.length - 1).remove();
          clones.pop();
          this.$stage.children().eq(0).remove();
          clones.pop();
        } else {
          clones.push(clones.length / 2);
          this.$stage.append(items[clones[clones.length - 1]].clone().addClass('cloned'));
          clones.push(items.length - 1 - (clones.length - 1) / 2);
          this.$stage.prepend(items[clones[clones.length - 1]].clone().addClass('cloned'));
        }
      }
    }
  }, {
    filter: ['width', 'items', 'settings'],
    run: function run() {
      var rtl = this.settings.rtl ? 1 : -1,
          width = (this.width() / this.settings.items).toFixed(3),
          coordinate = 0,
          merge,
          i,
          n;

      this._coordinates = [];
      for (i = 0, n = this._clones.length + this._items.length; i < n; i++) {
        merge = this._mergers[this.relative(i)];
        merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;
        coordinate += (this.settings.autoWidth ? this._items[this.relative(i)].width() + this.settings.margin : width * merge) * rtl;

        this._coordinates.push(coordinate);
      }
    }
  }, {
    filter: ['width', 'items', 'settings'],
    run: function run() {
      var i,
          n,
          width = (this.width() / this.settings.items).toFixed(3),
          css = {
        'width': Math.abs(this._coordinates[this._coordinates.length - 1]) + this.settings.stagePadding * 2,
        'padding-left': this.settings.stagePadding || '',
        'padding-right': this.settings.stagePadding || ''
      };

      this.$stage.css(css);

      css = { 'width': this.settings.autoWidth ? 'auto' : width - this.settings.margin };
      css[this.settings.rtl ? 'margin-left' : 'margin-right'] = this.settings.margin;

      if (!this.settings.autoWidth && $.grep(this._mergers, function (v) {
        return v > 1;
      }).length > 0) {
        for (i = 0, n = this._coordinates.length; i < n; i++) {
          css.width = Math.abs(this._coordinates[i]) - Math.abs(this._coordinates[i - 1] || 0) - this.settings.margin;
          this.$stage.children().eq(i).css(css);
        }
      } else {
        this.$stage.children().css(css);
      }
    }
  }, {
    filter: ['width', 'items', 'settings'],
    run: function run(cache) {
      cache.current && this.reset(this.$stage.children().index(cache.current));
    }
  }, {
    filter: ['position'],
    run: function run() {
      this.animate(this.coordinates(this._current));
    }
  }, {
    filter: ['width', 'position', 'items', 'settings'],
    run: function run() {
      var rtl = this.settings.rtl ? 1 : -1,
          padding = this.settings.stagePadding * 2,
          begin = this.coordinates(this.current()) + padding,
          end = begin + this.width() * rtl,
          inner,
          outer,
          matches = [],
          i,
          n;

      for (i = 0, n = this._coordinates.length; i < n; i++) {
        inner = this._coordinates[i - 1] || 0;
        outer = Math.abs(this._coordinates[i]) + padding * rtl;

        if (this.op(inner, '<=', begin) && this.op(inner, '>', end) || this.op(outer, '<', begin) && this.op(outer, '>', end)) {
          matches.push(i);
        }
      }

      this.$stage.children('.' + this.settings.activeClass).removeClass(this.settings.activeClass);
      this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass(this.settings.activeClass);

      if (this.settings.center) {
        this.$stage.children('.' + this.settings.centerClass).removeClass(this.settings.centerClass);
        this.$stage.children().eq(this.current()).addClass(this.settings.centerClass);
      }
    }
  }];

  /**
   * Initializes the carousel.
   * @protected
   */
  Owl.prototype.initialize = function () {
    this.trigger('initialize');

    this.$element.addClass(this.settings.baseClass).addClass(this.settings.themeClass).toggleClass('owl-rtl', this.settings.rtl);

    // check support
    this.browserSupport();

    if (this.settings.autoWidth && this.state.imagesLoaded !== true) {
      var imgs, nestedSelector, width;
      imgs = this.$element.find('img');
      nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
      width = this.$element.children(nestedSelector).width();

      if (imgs.length && width <= 0) {
        this.preloadAutoWidthImages(imgs);
        return false;
      }
    }

    this.$element.addClass('owl-loading');

    // create stage
    this.$stage = $('<' + this.settings.stageElement + ' class="owl-stage"/>').wrap('<div class="owl-stage-outer">');

    // append stage
    this.$element.append(this.$stage.parent());

    // append content
    this.replace(this.$element.children().not(this.$stage.parent()));

    // set view width
    this._width = this.$element.width();

    // update view
    this.refresh();

    this.$element.removeClass('owl-loading').addClass('owl-loaded');

    // attach generic events
    this.eventsCall();

    // attach generic events
    this.internalEvents();

    // attach custom control events
    this.addTriggerableEvents();

    this.trigger('initialized');
  };

  /**
   * Setups the current settings.
   * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
   * @todo Support for media queries by using `matchMedia` would be nice.
   * @public
   */
  Owl.prototype.setup = function () {
    var viewport = this.viewport(),
        overwrites = this.options.responsive,
        match = -1,
        settings = null;

    if (!overwrites) {
      settings = $.extend({}, this.options);
    } else {
      $.each(overwrites, function (breakpoint) {
        if (breakpoint <= viewport && breakpoint > match) {
          match = Number(breakpoint);
        }
      });

      settings = $.extend({}, this.options, overwrites[match]);
      delete settings.responsive;

      // responsive class
      if (settings.responsiveClass) {
        this.$element.attr('class', function (i, c) {
          return c.replace(/\b owl-responsive-\S+/g, '');
        }).addClass('owl-responsive-' + match);
      }
    }

    if (this.settings === null || this._breakpoint !== match) {
      this.trigger('change', { property: { name: 'settings', value: settings } });
      this._breakpoint = match;
      this.settings = settings;
      this.invalidate('settings');
      this.trigger('changed', { property: { name: 'settings', value: this.settings } });
    }
  };

  /**
   * Updates option logic if necessery.
   * @protected
   */
  Owl.prototype.optionsLogic = function () {
    // Toggle Center class
    this.$element.toggleClass('owl-center', this.settings.center);

    // if items number is less than in body
    if (this.settings.loop && this._items.length < this.settings.items) {
      this.settings.loop = false;
    }

    if (this.settings.autoWidth) {
      this.settings.stagePadding = false;
      this.settings.merge = false;
    }
  };

  /**
   * Prepares an item before add.
   * @todo Rename event parameter `content` to `item`.
   * @protected
   * @returns {jQuery|HTMLElement} - The item container.
   */
  Owl.prototype.prepare = function (item) {
    var event = this.trigger('prepare', { content: item });

    if (!event.data) {
      event.data = $('<' + this.settings.itemElement + '/>').addClass(this.settings.itemClass).append(item);
    }

    this.trigger('prepared', { content: event.data });

    return event.data;
  };

  /**
   * Updates the view.
   * @public
   */
  Owl.prototype.update = function () {
    var i = 0,
        n = this._pipe.length,
        filter = $.proxy(function (p) {
      return this[p];
    }, this._invalidated),
        cache = {};

    while (i < n) {
      if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
        this._pipe[i].run(cache);
      }
      i++;
    }

    this._invalidated = {};
  };

  /**
   * Gets the width of the view.
   * @public
   * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
   * @returns {Number} - The width of the view in pixel.
   */
  Owl.prototype.width = function (dimension) {
    dimension = dimension || Owl.Width.Default;
    switch (dimension) {
      case Owl.Width.Inner:
      case Owl.Width.Outer:
        return this._width;
      default:
        return this._width - this.settings.stagePadding * 2 + this.settings.margin;
    }
  };

  /**
   * Refreshes the carousel primarily for adaptive purposes.
   * @public
   */
  Owl.prototype.refresh = function () {
    if (this._items.length === 0) {
      return false;
    }

    var start = new Date().getTime();

    this.trigger('refresh');

    this.setup();

    this.optionsLogic();

    // hide and show methods helps here to set a proper widths,
    // this prevents scrollbar to be calculated in stage width
    this.$stage.addClass('owl-refresh');

    this.update();

    this.$stage.removeClass('owl-refresh');

    this.state.orientation = window.orientation;

    this.watchVisibility();

    this.trigger('refreshed');
  };

  /**
   * Save internal event references and add event based functions.
   * @protected
   */
  Owl.prototype.eventsCall = function () {
    // Save events references
    this.e._onDragStart = $.proxy(function (e) {
      this.onDragStart(e);
    }, this);
    this.e._onDragMove = $.proxy(function (e) {
      this.onDragMove(e);
    }, this);
    this.e._onDragEnd = $.proxy(function (e) {
      this.onDragEnd(e);
    }, this);
    this.e._onResize = $.proxy(function (e) {
      this.onResize(e);
    }, this);
    this.e._transitionEnd = $.proxy(function (e) {
      this.transitionEnd(e);
    }, this);
    this.e._preventClick = $.proxy(function (e) {
      this.preventClick(e);
    }, this);
  };

  /**
   * Checks window `resize` event.
   * @protected
   */
  Owl.prototype.onThrottledResize = function () {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(this.e._onResize, this.settings.responsiveRefreshRate);
  };

  /**
   * Checks window `resize` event.
   * @protected
   */
  Owl.prototype.onResize = function () {
    if (!this._items.length) {
      return false;
    }

    if (this._width === this.$element.width()) {
      return false;
    }

    if (this.trigger('resize').isDefaultPrevented()) {
      return false;
    }

    this._width = this.$element.width();

    this.invalidate('width');

    this.refresh();

    this.trigger('resized');
  };

  /**
   * Checks for touch/mouse drag event type and add run event handlers.
   * @protected
   */
  Owl.prototype.eventsRouter = function (event) {
    var type = event.type;

    if (type === "mousedown" || type === "touchstart") {
      this.onDragStart(event);
    } else if (type === "mousemove" || type === "touchmove") {
      this.onDragMove(event);
    } else if (type === "mouseup" || type === "touchend") {
      this.onDragEnd(event);
    } else if (type === "touchcancel") {
      this.onDragEnd(event);
    }
  };

  /**
   * Checks for touch/mouse drag options and add necessery event handlers.
   * @protected
   */
  Owl.prototype.internalEvents = function () {
    var isTouch = isTouchSupport(),
        isTouchIE = isTouchSupportIE();

    if (this.settings.mouseDrag) {
      this.$stage.on('mousedown', $.proxy(function (event) {
        this.eventsRouter(event);
      }, this));
      this.$stage.on('dragstart', function () {
        return false;
      });
      this.$stage.get(0).onselectstart = function () {
        return false;
      };
    } else {
      this.$element.addClass('owl-text-select-on');
    }

    if (this.settings.touchDrag && !isTouchIE) {
      this.$stage.on('touchstart touchcancel', $.proxy(function (event) {
        this.eventsRouter(event);
      }, this));
    }

    // catch transitionEnd event
    if (this.transitionEndVendor) {
      this.on(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd, false);
    }

    // responsive
    if (this.settings.responsive !== false) {
      this.on(window, 'resize', $.proxy(this.onThrottledResize, this));
    }
  };

  /**
   * Handles touchstart/mousedown event.
   * @protected
   * @param {Event} event - The event arguments.
   */
  Owl.prototype.onDragStart = function (event) {
    var ev, isTouchEvent, pageX, pageY, animatedPos;

    ev = event.originalEvent || event || window.event;

    // prevent right click
    if (ev.which === 3 || this.state.isTouch) {
      return false;
    }

    if (ev.type === 'mousedown') {
      this.$stage.addClass('owl-grab');
    }

    this.trigger('drag');
    this.drag.startTime = new Date().getTime();
    this.speed(0);
    this.state.isTouch = true;
    this.state.isScrolling = false;
    this.state.isSwiping = false;
    this.drag.distance = 0;

    pageX = getTouches(ev).x;
    pageY = getTouches(ev).y;

    // get stage position left
    this.drag.offsetX = this.$stage.position().left;
    this.drag.offsetY = this.$stage.position().top;

    if (this.settings.rtl) {
      this.drag.offsetX = this.$stage.position().left + this.$stage.width() - this.width() + this.settings.margin;
    }

    // catch position // ie to fix
    if (this.state.inMotion && this.support3d) {
      animatedPos = this.getTransformProperty();
      this.drag.offsetX = animatedPos;
      this.animate(animatedPos);
      this.state.inMotion = true;
    } else if (this.state.inMotion && !this.support3d) {
      this.state.inMotion = false;
      return false;
    }

    this.drag.startX = pageX - this.drag.offsetX;
    this.drag.startY = pageY - this.drag.offsetY;

    this.drag.start = pageX - this.drag.startX;
    this.drag.targetEl = ev.target || ev.srcElement;
    this.drag.updatedX = this.drag.start;

    // to do/check
    // prevent links and images dragging;
    if (this.drag.targetEl.tagName === "IMG" || this.drag.targetEl.tagName === "A") {
      this.drag.targetEl.draggable = false;
    }

    $(document).on('mousemove.owl.dragEvents mouseup.owl.dragEvents touchmove.owl.dragEvents touchend.owl.dragEvents', $.proxy(function (event) {
      this.eventsRouter(event);
    }, this));
  };

  /**
   * Handles the touchmove/mousemove events.
   * @todo Simplify
   * @protected
   * @param {Event} event - The event arguments.
   */
  Owl.prototype.onDragMove = function (event) {
    var ev, isTouchEvent, pageX, pageY, minValue, maxValue, pull;

    if (!this.state.isTouch) {
      return;
    }

    if (this.state.isScrolling) {
      return;
    }

    ev = event.originalEvent || event || window.event;

    pageX = getTouches(ev).x;
    pageY = getTouches(ev).y;

    // Drag Direction
    this.drag.currentX = pageX - this.drag.startX;
    this.drag.currentY = pageY - this.drag.startY;
    this.drag.distance = this.drag.currentX - this.drag.offsetX;

    // Check move direction
    if (this.drag.distance < 0) {
      this.state.direction = this.settings.rtl ? 'right' : 'left';
    } else if (this.drag.distance > 0) {
      this.state.direction = this.settings.rtl ? 'left' : 'right';
    }
    // Loop
    if (this.settings.loop) {
      if (this.op(this.drag.currentX, '>', this.coordinates(this.minimum())) && this.state.direction === 'right') {
        this.drag.currentX -= (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length);
      } else if (this.op(this.drag.currentX, '<', this.coordinates(this.maximum())) && this.state.direction === 'left') {
        this.drag.currentX += (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length);
      }
    } else {
      // pull
      minValue = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
      maxValue = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
      pull = this.settings.pullDrag ? this.drag.distance / 5 : 0;
      this.drag.currentX = Math.max(Math.min(this.drag.currentX, minValue + pull), maxValue + pull);
    }

    // Lock browser if swiping horizontal

    if (this.drag.distance > 8 || this.drag.distance < -8) {
      if (ev.preventDefault !== undefined) {
        ev.preventDefault();
      } else {
        ev.returnValue = false;
      }
      this.state.isSwiping = true;
    }

    this.drag.updatedX = this.drag.currentX;

    // Lock Owl if scrolling
    if ((this.drag.currentY > 16 || this.drag.currentY < -16) && this.state.isSwiping === false) {
      this.state.isScrolling = true;
      this.drag.updatedX = this.drag.start;
    }

    this.animate(this.drag.updatedX);
  };

  /**
   * Handles the touchend/mouseup events.
   * @protected
   */
  Owl.prototype.onDragEnd = function (event) {
    var compareTimes, distanceAbs, closest;

    if (!this.state.isTouch) {
      return;
    }

    if (event.type === 'mouseup') {
      this.$stage.removeClass('owl-grab');
    }

    this.trigger('dragged');

    // prevent links and images dragging;
    this.drag.targetEl.removeAttribute("draggable");

    // remove drag event listeners

    this.state.isTouch = false;
    this.state.isScrolling = false;
    this.state.isSwiping = false;

    // to check
    if (this.drag.distance === 0 && this.state.inMotion !== true) {
      this.state.inMotion = false;
      return false;
    }

    // prevent clicks while scrolling

    this.drag.endTime = new Date().getTime();
    compareTimes = this.drag.endTime - this.drag.startTime;
    distanceAbs = Math.abs(this.drag.distance);

    // to test
    if (distanceAbs > 3 || compareTimes > 300) {
      this.removeClick(this.drag.targetEl);
    }

    closest = this.closest(this.drag.updatedX);

    this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
    this.current(closest);
    this.invalidate('position');
    this.update();

    // if pullDrag is off then fire transitionEnd event manually when stick
    // to border
    if (!this.settings.pullDrag && this.drag.updatedX === this.coordinates(closest)) {
      this.transitionEnd();
    }

    this.drag.distance = 0;

    $(document).off('.owl.dragEvents');
  };

  /**
   * Attaches `preventClick` to disable link while swipping.
   * @protected
   * @param {HTMLElement} [target] - The target of the `click` event.
   */
  Owl.prototype.removeClick = function (target) {
    this.drag.targetEl = target;
    $(target).on('click.preventClick', this.e._preventClick);
    // to make sure click is removed:
    window.setTimeout(function () {
      $(target).off('click.preventClick');
    }, 300);
  };

  /**
   * Suppresses click event.
   * @protected
   * @param {Event} ev - The event arguments.
   */
  Owl.prototype.preventClick = function (ev) {
    if (ev.preventDefault) {
      ev.preventDefault();
    } else {
      ev.returnValue = false;
    }
    if (ev.stopPropagation) {
      ev.stopPropagation();
    }
    $(ev.target).off('click.preventClick');
  };

  /**
   * Catches stage position while animate (only CSS3).
   * @protected
   * @returns
   */
  Owl.prototype.getTransformProperty = function () {
    var transform, matrix3d;

    transform = window.getComputedStyle(this.$stage.get(0), null).getPropertyValue(this.vendorName + 'transform');
    // var transform = this.$stage.css(this.vendorName + 'transform')
    transform = transform.replace(/matrix(3d)?\(|\)/g, '').split(',');
    matrix3d = transform.length === 16;

    return matrix3d !== true ? transform[4] : transform[12];
  };

  /**
   * Gets absolute position of the closest item for a coordinate.
   * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
   * @protected
   * @param {Number} coordinate - The coordinate in pixel.
   * @return {Number} - The absolute position of the closest item.
   */
  Owl.prototype.closest = function (coordinate) {
    var position = -1,
        pull = 30,
        width = this.width(),
        coordinates = this.coordinates();

    if (!this.settings.freeDrag) {
      // check closest item
      $.each(coordinates, $.proxy(function (index, value) {
        if (coordinate > value - pull && coordinate < value + pull) {
          position = index;
        } else if (this.op(coordinate, '<', value) && this.op(coordinate, '>', coordinates[index + 1] || value - width)) {
          position = this.state.direction === 'left' ? index + 1 : index;
        }
        return position === -1;
      }, this));
    }

    if (!this.settings.loop) {
      // non loop boundries
      if (this.op(coordinate, '>', coordinates[this.minimum()])) {
        position = coordinate = this.minimum();
      } else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
        position = coordinate = this.maximum();
      }
    }

    return position;
  };

  /**
   * Animates the stage.
   * @public
   * @param {Number} coordinate - The coordinate in pixels.
   */
  Owl.prototype.animate = function (coordinate) {
    this.trigger('translate');
    this.state.inMotion = this.speed() > 0;

    if (this.support3d) {
      this.$stage.css({
        transform: 'translate3d(' + coordinate + 'px' + ',0px, 0px)',
        transition: this.speed() / 1000 + 's ' + this.settings.slideTransition
      });
    } else if (this.state.isTouch) {
      this.$stage.css({
        left: coordinate + 'px'
      });
    } else {
      this.$stage.animate({
        left: coordinate
      }, this.speed() / 1000, this.settings.fallbackEasing, $.proxy(function () {
        if (this.state.inMotion) {
          this.transitionEnd();
        }
      }, this));
    }
  };

  /**
   * Sets the absolute position of the current item.
   * @public
   * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
   * @returns {Number} - The absolute position of the current item.
   */
  Owl.prototype.current = function (position) {
    if (position === undefined) {
      return this._current;
    }

    if (this._items.length === 0) {
      return undefined;
    }

    position = this.normalize(position);

    if (this._current !== position) {
      var event = this.trigger('change', { property: { name: 'position', value: position } });

      if (event.data !== undefined) {
        position = this.normalize(event.data);
      }

      this._current = position;

      this.invalidate('position');

      this.trigger('changed', { property: { name: 'position', value: this._current } });
    }

    return this._current;
  };

  /**
   * Invalidates the given part of the update routine.
   * @param {String} part - The part to invalidate.
   */
  Owl.prototype.invalidate = function (part) {
    this._invalidated[part] = true;
  };

  /**
   * Resets the absolute position of the current item.
   * @public
   * @param {Number} position - The absolute position of the new item.
   */
  Owl.prototype.reset = function (position) {
    position = this.normalize(position);

    if (position === undefined) {
      return;
    }

    this._speed = 0;
    this._current = position;

    this.suppress(['translate', 'translated']);

    this.animate(this.coordinates(position));

    this.release(['translate', 'translated']);
  };

  /**
   * Normalizes an absolute or a relative position for an item.
   * @public
   * @param {Number} position - The absolute or relative position to normalize.
   * @param {Boolean} [relative=false] - Whether the given position is relative or not.
   * @returns {Number} - The normalized position.
   */
  Owl.prototype.normalize = function (position, relative) {
    var n = relative ? this._items.length : this._items.length + this._clones.length;

    if (!$.isNumeric(position) || n < 1) {
      return undefined;
    }

    if (this._clones.length) {
      position = (position % n + n) % n;
    } else {
      position = Math.max(this.minimum(relative), Math.min(this.maximum(relative), position));
    }

    return position;
  };

  /**
   * Converts an absolute position for an item into a relative position.
   * @public
   * @param {Number} position - The absolute position to convert.
   * @returns {Number} - The converted position.
   */
  Owl.prototype.relative = function (position) {
    position = this.normalize(position);
    position = position - this._clones.length / 2;
    return this.normalize(position, true);
  };

  /**
   * Gets the maximum position for an item.
   * @public
   * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
   * @returns {Number}
   */
  Owl.prototype.maximum = function (relative) {
    var maximum,
        width,
        i = 0,
        coordinate,
        settings = this.settings;

    if (relative) {
      return this._items.length - 1;
    }

    if (!settings.loop && settings.center) {
      maximum = this._items.length - 1;
    } else if (!settings.loop && !settings.center) {
      maximum = this._items.length - settings.items;
    } else if (settings.loop || settings.center) {
      maximum = this._items.length + settings.items;
    } else if (settings.autoWidth || settings.merge) {
      revert = settings.rtl ? 1 : -1;
      width = this.$stage.width() - this.$element.width();
      while (coordinate = this.coordinates(i)) {
        if (coordinate * revert >= width) {
          break;
        }
        maximum = ++i;
      }
    } else {
      throw 'Can not detect maximum absolute position.';
    }

    return maximum;
  };

  /**
   * Gets the minimum position for an item.
   * @public
   * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
   * @returns {Number}
   */
  Owl.prototype.minimum = function (relative) {
    if (relative) {
      return 0;
    }

    return this._clones.length / 2;
  };

  /**
   * Gets an item at the specified relative position.
   * @public
   * @param {Number} [position] - The relative position of the item.
   * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
   */
  Owl.prototype.items = function (position) {
    if (position === undefined) {
      return this._items.slice();
    }

    position = this.normalize(position, true);
    return this._items[position];
  };

  /**
   * Gets an item at the specified relative position.
   * @public
   * @param {Number} [position] - The relative position of the item.
   * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
   */
  Owl.prototype.mergers = function (position) {
    if (position === undefined) {
      return this._mergers.slice();
    }

    position = this.normalize(position, true);
    return this._mergers[position];
  };

  /**
   * Gets the absolute positions of clones for an item.
   * @public
   * @param {Number} [position] - The relative position of the item.
   * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
   */
  Owl.prototype.clones = function (position) {
    var odd = this._clones.length / 2,
        even = odd + this._items.length,
        map = function map(index) {
      return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2;
    };

    if (position === undefined) {
      return $.map(this._clones, function (v, i) {
        return map(i);
      });
    }

    return $.map(this._clones, function (v, i) {
      return v === position ? map(i) : null;
    });
  };

  /**
   * Sets the current animation speed.
   * @public
   * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
   * @returns {Number} - The current animation speed in milliseconds.
   */
  Owl.prototype.speed = function (speed) {
    if (speed !== undefined) {
      this._speed = speed;
    }

    return this._speed;
  };

  /**
   * Gets the coordinate of an item.
   * @todo The name of this method is missleanding.
   * @public
   * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
   * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
   */
  Owl.prototype.coordinates = function (position) {
    var coordinate = null;

    if (position === undefined) {
      return $.map(this._coordinates, $.proxy(function (coordinate, index) {
        return this.coordinates(index);
      }, this));
    }

    if (this.settings.center) {
      coordinate = this._coordinates[position];
      coordinate += (this.width() - coordinate + (this._coordinates[position - 1] || 0)) / 2 * (this.settings.rtl ? -1 : 1);
    } else {
      coordinate = this._coordinates[position - 1] || 0;
    }

    return coordinate;
  };

  /**
   * Calculates the speed for a translation.
   * @protected
   * @param {Number} from - The absolute position of the start item.
   * @param {Number} to - The absolute position of the target item.
   * @param {Number} [factor=undefined] - The time factor in milliseconds.
   * @returns {Number} - The time in milliseconds for the translation.
   */
  Owl.prototype.duration = function (from, to, factor) {
    return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs(factor || this.settings.smartSpeed);
  };

  /**
   * Slides to the specified item.
   * @public
   * @param {Number} position - The position of the item.
   * @param {Number} [speed] - The time in milliseconds for the transition.
   */
  Owl.prototype.to = function (position, speed) {
    if (this.settings.loop) {
      var distance = position - this.relative(this.current()),
          revert = this.current(),
          before = this.current(),
          after = this.current() + distance,
          direction = before - after < 0 ? true : false,
          items = this._clones.length + this._items.length;

      if (after < this.settings.items && direction === false) {
        revert = before + this._items.length;
        this.reset(revert);
      } else if (after >= items - this.settings.items && direction === true) {
        revert = before - this._items.length;
        this.reset(revert);
      }
      window.clearTimeout(this.e._goToLoop);
      this.e._goToLoop = window.setTimeout($.proxy(function () {
        this.speed(this.duration(this.current(), revert + distance, speed));
        this.current(revert + distance);
        this.update();
      }, this), 30);
    } else {
      this.speed(this.duration(this.current(), position, speed));
      this.current(position);
      this.update();
    }
  };

  /**
   * Slides to the next item.
   * @public
   * @param {Number} [speed] - The time in milliseconds for the transition.
   */
  Owl.prototype.next = function (speed) {
    speed = speed || false;
    this.to(this.relative(this.current()) + 1, speed);
  };

  /**
   * Slides to the previous item.
   * @public
   * @param {Number} [speed] - The time in milliseconds for the transition.
   */
  Owl.prototype.prev = function (speed) {
    speed = speed || false;
    this.to(this.relative(this.current()) - 1, speed);
  };

  /**
   * Handles the end of an animation.
   * @protected
   * @param {Event} event - The event arguments.
   */
  Owl.prototype.transitionEnd = function (event) {

    // if css2 animation then event object is undefined
    if (event !== undefined) {
      event.stopPropagation();

      // Catch only owl-stage transitionEnd event
      if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
        return false;
      }
    }

    this.state.inMotion = false;
    this.trigger('translated');
  };

  /**
   * Gets viewport width.
   * @protected
   * @return {Number} - The width in pixel.
   */
  Owl.prototype.viewport = function () {
    var width;
    if (this.options.responsiveBaseElement !== window) {
      width = $(this.options.responsiveBaseElement).width();
    } else if (window.innerWidth) {
      width = window.innerWidth;
    } else if (document.documentElement && document.documentElement.clientWidth) {
      width = document.documentElement.clientWidth;
    } else {
      throw 'Can not detect viewport width.';
    }
    return width;
  };

  /**
   * Replaces the current content.
   * @public
   * @param {HTMLElement|jQuery|String} content - The new content.
   */
  Owl.prototype.replace = function (content) {
    this.$stage.empty();
    this._items = [];

    if (content) {
      content = content instanceof jQuery ? content : $(content);
    }

    if (this.settings.nestedItemSelector) {
      content = content.find('.' + this.settings.nestedItemSelector);
    }

    content.filter(function () {
      return this.nodeType === 1;
    }).each($.proxy(function (index, item) {
      item = this.prepare(item);
      this.$stage.append(item);
      this._items.push(item);
      this._mergers.push(item.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
    }, this));

    this.reset($.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

    this.invalidate('items');
  };

  /**
   * Adds an item.
   * @todo Use `item` instead of `content` for the event arguments.
   * @public
   * @param {HTMLElement|jQuery|String} content - The item content to add.
   * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
   */
  Owl.prototype.add = function (content, position) {
    position = position === undefined ? this._items.length : this.normalize(position, true);

    this.trigger('add', { content: content, position: position });

    if (this._items.length === 0 || position === this._items.length) {
      this.$stage.append(content);
      this._items.push(content);
      this._mergers.push(content.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
    } else {
      this._items[position].before(content);
      this._items.splice(position, 0, content);
      this._mergers.splice(position, 0, content.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
    }

    this.invalidate('items');

    this.trigger('added', { content: content, position: position });
  };

  /**
   * Removes an item by its position.
   * @todo Use `item` instead of `content` for the event arguments.
   * @public
   * @param {Number} position - The relative position of the item to remove.
   */
  Owl.prototype.remove = function (position) {
    position = this.normalize(position, true);

    if (position === undefined) {
      return;
    }

    this.trigger('remove', { content: this._items[position], position: position });

    this._items[position].remove();
    this._items.splice(position, 1);
    this._mergers.splice(position, 1);

    this.invalidate('items');

    this.trigger('removed', { content: null, position: position });
  };

  /**
   * Adds triggerable events.
   * @protected
   */
  Owl.prototype.addTriggerableEvents = function () {
    var handler = $.proxy(function (callback, event) {
      return $.proxy(function (e) {
        if (e.relatedTarget !== this) {
          this.suppress([event]);
          callback.apply(this, [].slice.call(arguments, 1));
          this.release([event]);
        }
      }, this);
    }, this);

    $.each({
      'next': this.next,
      'prev': this.prev,
      'to': this.to,
      'destroy': this.destroy,
      'refresh': this.refresh,
      'replace': this.replace,
      'add': this.add,
      'remove': this.remove
    }, $.proxy(function (event, callback) {
      this.$element.on(event + '.owl.carousel', handler(callback, event + '.owl.carousel'));
    }, this));
  };

  /**
   * Watches the visibility of the carousel element.
   * @protected
   */
  Owl.prototype.watchVisibility = function () {

    // test on zepto
    if (!isElVisible(this.$element.get(0))) {
      this.$element.addClass('owl-hidden');
      window.clearInterval(this.e._checkVisibile);
      this.e._checkVisibile = window.setInterval($.proxy(checkVisible, this), 500);
    }

    function isElVisible(el) {
      return el.offsetWidth > 0 && el.offsetHeight > 0;
    }

    function checkVisible() {
      if (isElVisible(this.$element.get(0))) {
        this.$element.removeClass('owl-hidden');
        this.refresh();
        window.clearInterval(this.e._checkVisibile);
      }
    }
  };

  /**
   * Preloads images with auto width.
   * @protected
   * @todo Still to test
   */
  Owl.prototype.preloadAutoWidthImages = function (imgs) {
    var loaded, that, $el, img;

    loaded = 0;
    that = this;
    imgs.each(function (i, el) {
      $el = $(el);
      img = new Image();

      img.onload = function () {
        loaded++;
        $el.attr('src', img.src);
        $el.css('opacity', 1);
        if (loaded >= imgs.length) {
          that.state.imagesLoaded = true;
          that.initialize();
        }
      };

      img.src = $el.attr('src') || $el.attr('data-src') || $el.attr('data-src-retina');
    });
  };

  /**
   * Destroys the carousel.
   * @public
   */
  Owl.prototype.destroy = function () {

    if (this.$element.hasClass(this.settings.themeClass)) {
      this.$element.removeClass(this.settings.themeClass);
    }

    if (this.settings.responsive !== false) {
      $(window).off('resize.owl.carousel');
    }

    if (this.transitionEndVendor) {
      this.off(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd);
    }

    for (var i in this._plugins) {
      this._plugins[i].destroy();
    }

    if (this.settings.mouseDrag || this.settings.touchDrag) {
      this.$stage.off('mousedown touchstart touchcancel');
      $(document).off('.owl.dragEvents');
      this.$stage.get(0).onselectstart = function () {};
      this.$stage.off('dragstart', function () {
        return false;
      });
    }

    // remove event handlers in the ".owl.carousel" namespace
    this.$element.off('.owl');

    this.$stage.children('.cloned').remove();
    this.e = null;
    this.$element.removeData('owlCarousel');

    this.$stage.children().contents().unwrap();
    this.$stage.children().unwrap();
    this.$stage.unwrap();
  };

  /**
   * Operators to calculate right-to-left and left-to-right.
   * @protected
   * @param {Number} [a] - The left side operand.
   * @param {String} [o] - The operator.
   * @param {Number} [b] - The right side operand.
   */
  Owl.prototype.op = function (a, o, b) {
    var rtl = this.settings.rtl;
    switch (o) {
      case '<':
        return rtl ? a > b : a < b;
      case '>':
        return rtl ? a < b : a > b;
      case '>=':
        return rtl ? a <= b : a >= b;
      case '<=':
        return rtl ? a >= b : a <= b;
      default:
        break;
    }
  };

  /**
   * Attaches to an internal event.
   * @protected
   * @param {HTMLElement} element - The event source.
   * @param {String} event - The event name.
   * @param {Function} listener - The event handler to attach.
   * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
   */
  Owl.prototype.on = function (element, event, listener, capture) {
    if (element.addEventListener) {
      element.addEventListener(event, listener, capture);
    } else if (element.attachEvent) {
      element.attachEvent('on' + event, listener);
    }
  };

  /**
   * Detaches from an internal event.
   * @protected
   * @param {HTMLElement} element - The event source.
   * @param {String} event - The event name.
   * @param {Function} listener - The attached event handler to detach.
   * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
   */
  Owl.prototype.off = function (element, event, listener, capture) {
    if (element.removeEventListener) {
      element.removeEventListener(event, listener, capture);
    } else if (element.detachEvent) {
      element.detachEvent('on' + event, listener);
    }
  };

  /**
   * Triggers an public event.
   * @protected
   * @param {String} name - The event name.
   * @param {*} [data=null] - The event data.
   * @param {String} [namespace=.owl.carousel] - The event namespace.
   * @returns {Event} - The event arguments.
   */
  Owl.prototype.trigger = function (name, data, namespace) {
    var status = {
      item: { count: this._items.length, index: this.current() }
    },
        handler = $.camelCase($.grep(['on', name, namespace], function (v) {
      return v;
    }).join('-').toLowerCase()),
        event = $.Event([name, 'owl', namespace || 'carousel'].join('.').toLowerCase(), $.extend({ relatedTarget: this }, status, data));

    if (!this._supress[name]) {
      $.each(this._plugins, function (name, plugin) {
        if (plugin.onTrigger) {
          plugin.onTrigger(event);
        }
      });

      this.$element.trigger(event);

      if (this.settings && typeof this.settings[handler] === 'function') {
        this.settings[handler].apply(this, event);
      }
    }

    return event;
  };

  /**
   * Suppresses events.
   * @protected
   * @param {Array.<String>} events - The events to suppress.
   */
  Owl.prototype.suppress = function (events) {
    $.each(events, $.proxy(function (index, event) {
      this._supress[event] = true;
    }, this));
  };

  /**
   * Releases suppressed events.
   * @protected
   * @param {Array.<String>} events - The events to release.
   */
  Owl.prototype.release = function (events) {
    $.each(events, $.proxy(function (index, event) {
      delete this._supress[event];
    }, this));
  };

  /**
   * Checks the availability of some browser features.
   * @protected
   */
  Owl.prototype.browserSupport = function () {
    this.support3d = isPerspective();

    if (this.support3d) {
      this.transformVendor = isTransform();

      // take transitionend event name by detecting transition
      var endVendors = ['transitionend', 'webkitTransitionEnd', 'transitionend', 'oTransitionEnd'];
      this.transitionEndVendor = endVendors[isTransition()];

      // take vendor name from transform name
      this.vendorName = this.transformVendor.replace(/Transform/i, '');
      this.vendorName = this.vendorName !== '' ? '-' + this.vendorName.toLowerCase() + '-' : '';
    }

    this.state.orientation = window.orientation;
  };

  /**
   * Get touch/drag coordinats.
   * @private
   * @param {event} - mousedown/touchstart event
   * @returns {object} - Contains X and Y of current mouse/touch position
   */

  function getTouches(event) {
    if (event.touches !== undefined) {
      return {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
      };
    }

    if (event.touches === undefined) {
      if (event.pageX !== undefined) {
        return {
          x: event.pageX,
          y: event.pageY
        };
      }

      if (event.pageX === undefined) {
        return {
          x: event.clientX,
          y: event.clientY
        };
      }
    }
  }

  /**
   * Checks for CSS support.
   * @private
   * @param {Array} array - The CSS properties to check for.
   * @returns {Array} - Contains the supported CSS property name and its index or `false`.
   */
  function isStyleSupported(array) {
    var p,
        s,
        fake = document.createElement('div'),
        list = array;
    for (p in list) {
      s = list[p];
      if (typeof fake.style[s] !== 'undefined') {
        fake = null;
        return [s, p];
      }
    }
    return [false];
  }

  /**
   * Checks for CSS transition support.
   * @private
   * @todo Realy bad design
   * @returns {Number}
   */
  function isTransition() {
    return isStyleSupported(['transition', 'WebkitTransition', 'MozTransition', 'OTransition'])[1];
  }

  /**
   * Checks for CSS transform support.
   * @private
   * @returns {String} The supported property name or false.
   */
  function isTransform() {
    return isStyleSupported(['transform', 'WebkitTransform', 'MozTransform', 'OTransform', 'msTransform'])[0];
  }

  /**
   * Checks for CSS perspective support.
   * @private
   * @returns {String} The supported property name or false.
   */
  function isPerspective() {
    return isStyleSupported(['perspective', 'webkitPerspective', 'MozPerspective', 'OPerspective', 'MsPerspective'])[0];
  }

  /**
   * Checks wether touch is supported or not.
   * @private
   * @returns {Boolean}
   */
  function isTouchSupport() {
    return 'ontouchstart' in window || !!navigator.msMaxTouchPoints;
  }

  /**
   * Checks wether touch is supported or not for IE.
   * @private
   * @returns {Boolean}
   */
  function isTouchSupportIE() {
    return window.navigator.msPointerEnabled;
  }

  /**
   * The jQuery Plugin for the Owl Carousel
   * @public
   */
  $.fn.owlCarousel = function (options) {
    return this.each(function () {
      if (!$(this).data('owlCarousel')) {
        $(this).data('owlCarousel', new Owl(this, options));
      }
    });
  };

  /**
   * The constructor for the jQuery Plugin
   * @public
   */
  $.fn.owlCarousel.Constructor = Owl;
})(window.Zepto || window.jQuery, window, document);

/**
* Lazy Plugin
* @version 2.0.0
* @author Bartosz Wojciechowski
* @license The MIT License (MIT)
*/
;(function ($, window, document, undefined) {

  /**
   * Creates the lazy plugin.
   * @class The Lazy Plugin
   * @param {Owl} carousel - The Owl Carousel
   */
  var Lazy = function Lazy(carousel) {

    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * Already loaded items.
     * @protected
     * @type {Array.<jQuery>}
     */
    this._loaded = [];

    /**
     * Event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'initialized.owl.carousel change.owl.carousel': $.proxy(function (e) {
        if (!e.namespace) {
          return;
        }

        if (!this._core.settings || !this._core.settings.lazyLoad) {
          return;
        }

        if (e.property && e.property.name == 'position' || e.type == 'initialized') {
          var settings = this._core.settings,
              n = settings.center && Math.ceil(settings.items / 2) || settings.items,
              i = settings.center && n * -1 || 0,
              position = (e.property && e.property.value || this._core.current()) + i,
              clones = this._core.clones().length,
              load = $.proxy(function (i, v) {
            this.load(v);
          }, this);

          while (i++ < n) {
            this.load(clones / 2 + this._core.relative(position));
            clones && $.each(this._core.clones(this._core.relative(position++)), load);
          }
        }
      }, this)
    };

    // set the default options
    this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

    // register event handler
    this._core.$element.on(this._handlers);
  };

  /**
   * Default options.
   * @public
   */
  Lazy.Defaults = {
    lazyLoad: false

    /**
     * Loads all resources of an item at the specified position.
     * @param {Number} position - The absolute position of the item.
     * @protected
     */
  };Lazy.prototype.load = function (position) {
    var $item = this._core.$stage.children().eq(position),
        $elements = $item && $item.find('.owl-lazy');

    if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
      return;
    }

    $elements.each($.proxy(function (index, element) {
      var $element = $(element),
          image,
          url = window.devicePixelRatio > 1 && $element.attr('data-src-retina') || $element.attr('data-src');

      this._core.trigger('load', { element: $element, url: url }, 'lazy');

      if ($element.is('img')) {
        $element.one('load.owl.lazy', $.proxy(function () {
          $element.css('opacity', 1);
          this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
        }, this)).attr('src', url);
      } else {
        image = new Image();
        image.onload = $.proxy(function () {
          $element.css({
            'background-image': 'url(' + url + ')',
            'opacity': '1'
          });
          this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
        }, this);
        image.src = url;
      }
    }, this));

    this._loaded.push($item.get(0));
  };

  /**
   * Destroys the plugin.
   * @public
   */
  Lazy.prototype.destroy = function () {
    var handler, property;

    for (handler in this.handlers) {
      this._core.$element.off(handler, this.handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;
})(window.Zepto || window.jQuery, window, document);

/**
* AutoHeight Plugin
* @version 2.0.0
* @author Bartosz Wojciechowski
* @license The MIT License (MIT)
*/
;(function ($, window, document, undefined) {

  /**
   * Creates the auto height plugin.
   * @class The Auto Height Plugin
   * @param {Owl} carousel - The Owl Carousel
   */
  var AutoHeight = function AutoHeight(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * All event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'initialized.owl.carousel': $.proxy(function () {
        if (this._core.settings.autoHeight) {
          this.update();
        }
      }, this),
      'changed.owl.carousel': $.proxy(function (e) {
        if (this._core.settings.autoHeight && e.property.name == 'position') {
          this.update();
        }
      }, this),
      'loaded.owl.lazy': $.proxy(function (e) {
        if (this._core.settings.autoHeight && e.element.closest('.' + this._core.settings.itemClass) === this._core.$stage.children().eq(this._core.current())) {
          this.update();
        }
      }, this)
    };

    // set default options
    this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

    // register event handlers
    this._core.$element.on(this._handlers);
  };

  /**
   * Default options.
   * @public
   */
  AutoHeight.Defaults = {
    autoHeight: false,
    autoHeightClass: 'owl-height'
  };

  /**
   * Updates the view.
   */
  AutoHeight.prototype.update = function () {
    this._core.$stage.parent().height(this._core.$stage.children().eq(this._core.current()).height()).addClass(this._core.settings.autoHeightClass);
  };

  AutoHeight.prototype.destroy = function () {
    var handler, property;

    for (handler in this._handlers) {
      this._core.$element.off(handler, this._handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;
})(window.Zepto || window.jQuery, window, document);

/**
* Video Plugin
* @version 2.0.0
* @author Bartosz Wojciechowski
* @license The MIT License (MIT)
*/
;(function ($, window, document, undefined) {

  /**
   * Creates the video plugin.
   * @class The Video Plugin
   * @param {Owl} carousel - The Owl Carousel
   */
  var Video = function Video(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * Cache all video URLs.
     * @protected
     * @type {Object}
     */
    this._videos = {};

    /**
     * Current playing item.
     * @protected
     * @type {jQuery}
     */
    this._playing = null;

    /**
     * Whether this is in fullscreen or not.
     * @protected
     * @type {Boolean}
     */
    this._fullscreen = false;

    /**
     * All event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'resize.owl.carousel': $.proxy(function (e) {
        if (this._core.settings.video && !this.isInFullScreen()) {
          e.preventDefault();
        }
      }, this),
      'refresh.owl.carousel changed.owl.carousel': $.proxy(function (e) {
        if (this._playing) {
          this.stop();
        }
      }, this),
      'prepared.owl.carousel': $.proxy(function (e) {
        var $element = $(e.content).find('.owl-video');
        if ($element.length) {
          // $element.css('display', 'none');
          this.fetch($element, $(e.content));
        }
      }, this)
    };

    // set default options
    this._core.options = $.extend({}, Video.Defaults, this._core.options);

    // register event handlers
    this._core.$element.on(this._handlers);

    this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function (e) {
      console.log('clicked');

      this.play(e);
    }, this));
  };

  /**
   * Default options.
   * @public
   */
  Video.Defaults = {
    video: false,
    videoHeight: false,
    videoWidth: false
  };

  /**
   * Gets the video ID and the type (YouTube/Vimeo only).
   * @protected
   * @param {jQuery} target - The target containing the video data.
   * @param {jQuery} item - The item containing the video.
   */
  Video.prototype.fetch = function (target, item) {

    var type = target.attr('data-vimeo-id') ? 'vimeo' : 'youtube',
        id = target.attr('data-vimeo-id') || target.attr('data-youtube-id'),
        width = target.attr('data-width') || this._core.settings.videoWidth,
        height = target.attr('data-height') || this._core.settings.videoHeight,
        url = target.attr('href');

    if (url) {
      id = url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

      if (id[3].indexOf('youtu') > -1) {
        type = 'youtube';
      } else if (id[3].indexOf('vimeo') > -1) {
        type = 'vimeo';
      } else {
        throw new Error('Video URL not supported.');
      }
      id = id[6];
    } else {
      throw new Error('Missing video URL.');
    }

    this._videos[url] = {
      type: type,
      id: id,
      width: width,
      height: height
    };

    item.attr('data-video', url);

    this.thumbnail(target, this._videos[url]);
  };

  /**
   * Creates video thumbnail.
   * @protected
   * @param {jQuery} target - The target containing the video data.
   * @param {Object} info - The video info object.
   * @see `fetch`
   */
  Video.prototype.thumbnail = function (target, video) {

    var tnLink,
        icon,
        path,
        dimensions = video.width && video.height ? 'style="width:' + video.width + 'px;height:' + video.height + 'px;"' : '',
        customTn = target.find('img'),
        srcType = 'src',
        lazyClass = '',
        settings = this._core.settings,
        create = function create(path) {
      icon = '<div class="owl-video-play-icon"></div>';

      if (settings.lazyLoad) {
        tnLink = '<div class="owl-video-tn ' + lazyClass + '" ' + srcType + '="' + path + '"></div>';
      } else {
        tnLink = '<div class="owl-video-tn" style="opacity:1;background-image:url(' + path + ')"></div>';
      }
      target.after(tnLink);
      target.after(icon);
    };

    // wrap video content into owl-video-wrapper div
    target.wrap('<div class="owl-video-wrapper"' + dimensions + '></div>');

    if (this._core.settings.lazyLoad) {
      srcType = 'data-src';
      lazyClass = 'owl-lazy';
    }

    // custom thumbnail
    if (customTn.length) {
      create(customTn.attr(srcType));
      // customTn.remove();
      return false;
    }

    if (video.type === 'youtube') {
      path = "http://img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
      create(path);
    } else if (video.type === 'vimeo') {
      $.ajax({
        type: 'GET',
        url: 'http://vimeo.com/api/v2/video/' + video.id + '.json',
        jsonp: 'callback',
        dataType: 'jsonp',
        success: function success(data) {
          path = data[0].thumbnail_large;
          create(path);
        }
      });
    }
  };

  /**
   * Stops the current video.
   * @public
   */
  Video.prototype.stop = function () {
    this._core.trigger('stop', null, 'video');
    this._playing.find('.owl-video-frame').remove();
    this._playing.find('img').css('display', 'block');
    this._playing.removeClass('owl-video-playing');
    this._playing = null;
  };

  /**
   * Starts the current video.
   * @public
   * @param {Event} ev - The event arguments.
   */
  Video.prototype.play = function (ev) {
    var target = $(ev.target || ev.srcElement),
        item = target.closest('.' + this._core.settings.itemClass),
        video = this._videos[item.attr('data-video')],
        width = video.width || '100%',
        height = video.height || this._core.$stage.height(),
        html,
        wrap;

    target.prev().find('img').css('display', 'none');

    this._core.trigger('play', null, 'video');

    if (this._playing) {
      this.stop();
    }

    if (video.type === 'youtube') {
      html = '<iframe width="' + width + '" height="' + height + '" src="http://www.youtube.com/embed/' + video.id + '?autoplay=1&v=' + video.id + '" frameborder="0" allowfullscreen></iframe>';
    } else if (video.type === 'vimeo') {
      html = '<iframe src="http://player.vimeo.com/video/' + video.id + '?autoplay=1" width="' + width + '" height="' + height + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    }

    item.addClass('owl-video-playing');
    this._playing = item;

    wrap = $('<div style="height:' + height + 'px; width:' + width + 'px" class="owl-video-frame">' + html + '</div>');
    target.after(wrap);
  };

  /**
   * Checks whether an video is currently in full screen mode or not.
   * @todo Bad style because looks like a readonly method but changes members.
   * @protected
   * @returns {Boolean}
   */
  Video.prototype.isInFullScreen = function () {

    // if Vimeo Fullscreen mode
    var element = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

    if (element && $(element).parent().hasClass('owl-video-frame')) {
      this._core.speed(0);
      this._fullscreen = true;
    }

    if (element && this._fullscreen && this._playing) {
      return false;
    }

    // comming back from fullscreen
    if (this._fullscreen) {
      this._fullscreen = false;
      return false;
    }

    // check full screen mode and window orientation
    if (this._playing) {
      if (this._core.state.orientation !== window.orientation) {
        this._core.state.orientation = window.orientation;
        return false;
      }
    }

    return true;
  };

  /**
   * Destroys the plugin.
   */
  Video.prototype.destroy = function () {
    var handler, property;

    this._core.$element.off('click.owl.video');

    for (handler in this._handlers) {
      this._core.$element.off(handler, this._handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.Video = Video;
})(window.Zepto || window.jQuery, window, document);

/**
* Animate Plugin
* @version 2.0.0
* @author Bartosz Wojciechowski
* @license The MIT License (MIT)
*/
;(function ($, window, document, undefined) {

  /**
   * Creates the animate plugin.
   * @class The Navigation Plugin
   * @param {Owl} scope - The Owl Carousel
   */
  var Animate = function Animate(scope) {
    this.core = scope;
    this.core.options = $.extend({}, Animate.Defaults, this.core.options);
    this.swapping = true;
    this.previous = undefined;
    this.next = undefined;

    this.handlers = {
      'change.owl.carousel': $.proxy(function (e) {
        if (e.property.name == 'position') {
          this.previous = this.core.current();
          this.next = e.property.value;
        }
      }, this),
      'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function (e) {
        this.swapping = e.type == 'translated';
      }, this),
      'translate.owl.carousel': $.proxy(function (e) {
        if (this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
          this.swap();
        }
      }, this)
    };

    this.core.$element.on(this.handlers);
  };

  /**
   * Default options.
   * @public
   */
  Animate.Defaults = {
    animateOut: false,
    animateIn: false
  };

  /**
   * Toggles the animation classes whenever an translations starts.
   * @protected
   * @returns {Boolean|undefined}
   */
  Animate.prototype.swap = function () {

    if (this.core.settings.items !== 1 || !this.core.support3d) {
      return;
    }

    this.core.speed(0);

    var left,
        clear = $.proxy(this.clear, this),
        previous = this.core.$stage.children().eq(this.previous),
        next = this.core.$stage.children().eq(this.next),
        incoming = this.core.settings.animateIn,
        outgoing = this.core.settings.animateOut;

    if (this.core.current() === this.previous) {
      return;
    }

    if (outgoing) {
      left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
      previous.css({ 'left': left + 'px' }).addClass('animated owl-animated-out').addClass(outgoing).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', clear);
    }

    if (incoming) {
      next.addClass('animated owl-animated-in').addClass(incoming).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', clear);
    }
  };

  Animate.prototype.clear = function (e) {
    $(e.target).css({ 'left': '' }).removeClass('animated owl-animated-out owl-animated-in').removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut);
    this.core.transitionEnd();
  };

  /**
   * Destroys the plugin.
   * @public
   */
  Animate.prototype.destroy = function () {
    var handler, property;

    for (handler in this.handlers) {
      this.core.$element.off(handler, this.handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.Animate = Animate;
})(window.Zepto || window.jQuery, window, document);

/**
* Autoplay Plugin
* @version 2.0.0
* @author Bartosz Wojciechowski
* @license The MIT License (MIT)
*/
;(function ($, window, document, undefined) {

  /**
   * Creates the autoplay plugin.
   * @class The Autoplay Plugin
   * @param {Owl} scope - The Owl Carousel
   */
  var Autoplay = function Autoplay(scope) {
    this.core = scope;
    this.core.options = $.extend({}, Autoplay.Defaults, this.core.options);

    this.handlers = {
      'translated.owl.carousel refreshed.owl.carousel': $.proxy(function () {
        this.autoplay();
      }, this),
      'play.owl.autoplay': $.proxy(function (e, t, s) {
        this.play(t, s);
      }, this),
      'stop.owl.autoplay': $.proxy(function () {
        this.stop();
      }, this),
      'mouseover.owl.autoplay': $.proxy(function () {
        if (this.core.settings.autoplayHoverPause) {
          this.pause();
        }
      }, this),
      'mouseleave.owl.autoplay': $.proxy(function () {

        if (this.core.settings.autoplayHoverPause && this.core.$element.find('.owl-video-playing').length == 0) {
          this.autoplay();
        }
      }, this)
    };

    this.core.$element.on(this.handlers);
  };

  /**
   * Default options.
   * @public
   */
  Autoplay.Defaults = {
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    autoplaySpeed: false
  };

  /**
   * @protected
   * @todo Must be documented.
   */
  Autoplay.prototype.autoplay = function () {
    if (this.core.settings.autoplay && !this.core.state.videoPlay) {
      window.clearTimeout(this.interval);

      this.interval = window.setTimeout($.proxy(function () {
        this.play();
      }, this), this.core.settings.autoplayTimeout);
    } else {
      window.clearTimeout(this.interval);
    }
  };

  /**
   * Starts the autoplay.
   * @public
   * @param {Number} [timeout] - ...
   * @param {Number} [speed] - ...
   * @returns {Boolean|undefined} - ...
   * @todo Must be documented.
   */
  Autoplay.prototype.play = function (timeout, speed) {
    // if tab is inactive - doesnt work in <IE10
    if (document.hidden === true) {
      return;
    }

    if (this.core.state.isTouch || this.core.state.isScrolling || this.core.state.isSwiping || this.core.state.inMotion) {
      return;
    }

    if (this.core.settings.autoplay === false) {
      window.clearInterval(this.interval);
      return;
    }

    this.core.next(this.core.settings.autoplaySpeed);
  };

  /**
   * Stops the autoplay.
   * @public
   */
  Autoplay.prototype.stop = function () {
    window.clearInterval(this.interval);
  };

  /**
   * Pauses the autoplay.
   * @public
   */
  Autoplay.prototype.pause = function () {
    window.clearInterval(this.interval);
  };

  /**
   * Destroys the plugin.
   */
  Autoplay.prototype.destroy = function () {
    var handler, property;

    window.clearInterval(this.interval);

    for (handler in this.handlers) {
      this.core.$element.off(handler, this.handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;
})(window.Zepto || window.jQuery, window, document);

/**
* Navigation Plugin
* @version 2.0.0
* @author Artus Kolanowski
* @license The MIT License (MIT)
*/
;(function ($, window, document, undefined) {
  'use strict';

  /**
   * Creates the navigation plugin.
   * @class The Navigation Plugin
   * @param {Owl} carousel - The Owl Carousel.
   */

  var Navigation = function Navigation(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * Indicates whether the plugin is initialized or not.
     * @protected
     * @type {Boolean}
     */
    this._initialized = false;

    /**
     * The current paging indexes.
     * @protected
     * @type {Array}
     */
    this._pages = [];

    /**
     * All DOM elements of the user interface.
     * @protected
     * @type {Object}
     */
    this._controls = {};

    /**
     * Markup for an indicator.
     * @protected
     * @type {Array.<String>}
     */
    this._templates = [];

    /**
     * The carousel element.
     * @type {jQuery}
     */
    this.$element = this._core.$element;

    /**
     * Overridden methods of the carousel.
     * @protected
     * @type {Object}
     */
    this._overrides = {
      next: this._core.next,
      prev: this._core.prev,
      to: this._core.to
    };

    /**
     * All event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'prepared.owl.carousel': $.proxy(function (e) {
        if (this._core.settings.dotsData) {
          this._templates.push($(e.content).find('[data-dot]').andSelf('[data-dot]').attr('data-dot'));
        }
      }, this),
      'add.owl.carousel': $.proxy(function (e) {
        if (this._core.settings.dotsData) {
          this._templates.splice(e.position, 0, $(e.content).find('[data-dot]').andSelf('[data-dot]').attr('data-dot'));
        }
      }, this),
      'remove.owl.carousel prepared.owl.carousel': $.proxy(function (e) {
        if (this._core.settings.dotsData) {
          this._templates.splice(e.position, 1);
        }
      }, this),
      'change.owl.carousel': $.proxy(function (e) {
        if (e.property.name == 'position') {
          if (!this._core.state.revert && !this._core.settings.loop && this._core.settings.navRewind) {
            var current = this._core.current(),
                maximum = this._core.maximum(),
                minimum = this._core.minimum();
            e.data = e.property.value > maximum ? current >= maximum ? minimum : maximum : e.property.value < minimum ? maximum : e.property.value;
          }
        }
      }, this),
      'changed.owl.carousel': $.proxy(function (e) {
        if (e.property.name == 'position') {
          this.draw();
        }
      }, this),
      'refreshed.owl.carousel': $.proxy(function () {
        if (!this._initialized) {
          this.initialize();
          this._initialized = true;
        }
        this._core.trigger('refresh', null, 'navigation');
        this.update();
        this.draw();
        this._core.trigger('refreshed', null, 'navigation');
      }, this)
    };

    // set default options
    this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

    // register event handlers
    this.$element.on(this._handlers);
  };

  /**
   * Default options.
   * @public
   * @todo Rename `slideBy` to `navBy`
   */
  Navigation.Defaults = {
    nav: false,
    navRewind: true,
    navText: ['prev', 'next'],
    navSpeed: false,
    navElement: 'div',
    navContainer: false,
    navContainerClass: 'owl-nav',
    navClass: ['owl-prev', 'owl-next'],
    slideBy: 1,
    dotClass: 'owl-dot',
    dotsClass: 'owl-dots',
    dots: true,
    dotsEach: false,
    dotData: false,
    dotsSpeed: false,
    dotsContainer: false,
    controlsClass: 'owl-controls'

    /**
     * Initializes the layout of the plugin and extends the carousel.
     * @protected
     */
  };Navigation.prototype.initialize = function () {
    var $container,
        override,
        options = this._core.settings;

    // create the indicator template
    if (!options.dotsData) {
      this._templates = [$('<div>').addClass(options.dotClass).append($('<span>')).prop('outerHTML')];
    }

    // create controls container if needed
    if (!options.navContainer || !options.dotsContainer) {
      this._controls.$container = $('<div>').addClass(options.controlsClass).appendTo(this.$element);
    }

    // create DOM structure for absolute navigation
    this._controls.$indicators = options.dotsContainer ? $(options.dotsContainer) : $('<div>').hide().addClass(options.dotsClass).appendTo(this.$element);

    this._controls.$indicators.on('click', 'div', $.proxy(function (e) {
      var index = $(e.target).parent().is(this._controls.$indicators) ? $(e.target).index() : $(e.target).parent().index();

      e.preventDefault();

      this.to(index, options.dotsSpeed);
    }, this));

    // create DOM structure for relative navigation
    $container = options.navContainer ? $(options.navContainer) : $('<div>').addClass(options.navContainerClass).prependTo(this._controls.$container);

    this._controls.$next = $('<' + options.navElement + '>');
    this._controls.$previous = this._controls.$next.clone();

    this._controls.$previous.addClass(options.navClass[0]).html(options.navText[0]).hide().prependTo($container).on('click', $.proxy(function (e) {
      this.prev(options.navSpeed);
    }, this));
    this._controls.$next.addClass(options.navClass[1]).html(options.navText[1]).hide().appendTo($container).on('click', $.proxy(function (e) {
      this.next(options.navSpeed);
    }, this));

    // override public methods of the carousel
    for (override in this._overrides) {
      this._core[override] = $.proxy(this[override], this);
    }
  };

  /**
   * Destroys the plugin.
   * @protected
   */
  Navigation.prototype.destroy = function () {
    var handler, control, property, override;

    for (handler in this._handlers) {
      this.$element.off(handler, this._handlers[handler]);
    }
    for (control in this._controls) {
      this._controls[control].remove();
    }
    for (override in this.overides) {
      this._core[override] = this._overrides[override];
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  /**
   * Updates the internal state.
   * @protected
   */
  Navigation.prototype.update = function () {
    var i,
        j,
        k,
        options = this._core.settings,
        lower = this._core.clones().length / 2,
        upper = lower + this._core.items().length,
        size = options.center || options.autoWidth || options.dotData ? 1 : options.dotsEach || options.items;

    if (options.slideBy !== 'page') {
      options.slideBy = Math.min(options.slideBy, options.items);
    }

    if (options.dots || options.slideBy == 'page') {
      this._pages = [];

      for (i = lower, j = 0, k = 0; i < upper; i++) {
        if (j >= size || j === 0) {
          this._pages.push({
            start: i - lower,
            end: i - lower + size - 1
          });
          j = 0, ++k;
        }
        j += this._core.mergers(this._core.relative(i));
      }
    }
  };

  /**
   * Draws the user interface.
   * @todo The option `dotData` wont work.
   * @protected
   */
  Navigation.prototype.draw = function () {
    var difference,
        i,
        html = '',
        options = this._core.settings,
        $items = this._core.$stage.children(),
        index = this._core.relative(this._core.current());

    if (options.nav && !options.loop && !options.navRewind) {
      this._controls.$previous.toggleClass('disabled', index <= 0);
      this._controls.$next.toggleClass('disabled', index >= this._core.maximum());
    }

    this._controls.$previous.toggle(options.nav);
    this._controls.$next.toggle(options.nav);

    if (options.dots) {
      difference = this._pages.length - this._controls.$indicators.children().length;

      if (options.dotData && difference !== 0) {
        for (i = 0; i < this._controls.$indicators.children().length; i++) {
          html += this._templates[this._core.relative(i)];
        }
        this._controls.$indicators.html(html);
      } else if (difference > 0) {
        html = new Array(difference + 1).join(this._templates[0]);
        this._controls.$indicators.append(html);
      } else if (difference < 0) {
        this._controls.$indicators.children().slice(difference).remove();
      }

      this._controls.$indicators.find('.active').removeClass('active');
      this._controls.$indicators.children().eq($.inArray(this.current(), this._pages)).addClass('active');
    }

    this._controls.$indicators.toggle(options.dots);
  };

  /**
   * Extends event data.
   * @protected
   * @param {Event} event - The event object which gets thrown.
   */
  Navigation.prototype.onTrigger = function (event) {
    var settings = this._core.settings;

    event.page = {
      index: $.inArray(this.current(), this._pages),
      count: this._pages.length,
      size: settings && (settings.center || settings.autoWidth || settings.dotData ? 1 : settings.dotsEach || settings.items)
    };
  };

  /**
   * Gets the current page position of the carousel.
   * @protected
   * @returns {Number}
   */
  Navigation.prototype.current = function () {
    var index = this._core.relative(this._core.current());
    return $.grep(this._pages, function (o) {
      return o.start <= index && o.end >= index;
    }).pop();
  };

  /**
   * Gets the current succesor/predecessor position.
   * @protected
   * @returns {Number}
   */
  Navigation.prototype.getPosition = function (successor) {
    var position,
        length,
        options = this._core.settings;

    if (options.slideBy == 'page') {
      position = $.inArray(this.current(), this._pages);
      length = this._pages.length;
      successor ? ++position : --position;
      position = this._pages[(position % length + length) % length].start;
    } else {
      position = this._core.relative(this._core.current());
      length = this._core.items().length;
      successor ? position += options.slideBy : position -= options.slideBy;
    }
    return position;
  };

  /**
   * Slides to the next item or page.
   * @public
   * @param {Number} [speed=false] - The time in milliseconds for the transition.
   */
  Navigation.prototype.next = function (speed) {
    $.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
  };

  /**
   * Slides to the previous item or page.
   * @public
   * @param {Number} [speed=false] - The time in milliseconds for the transition.
   */
  Navigation.prototype.prev = function (speed) {
    $.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
  };

  /**
   * Slides to the specified item or page.
   * @public
   * @param {Number} position - The position of the item or page.
   * @param {Number} [speed] - The time in milliseconds for the transition.
   * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
   */
  Navigation.prototype.to = function (position, speed, standard) {
    var length;

    if (!standard) {
      length = this._pages.length;
      $.proxy(this._overrides.to, this._core)(this._pages[(position % length + length) % length].start, speed);
    } else {
      $.proxy(this._overrides.to, this._core)(position, speed);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;
})(window.Zepto || window.jQuery, window, document);

/**
* Hash Plugin
* @version 2.0.0
* @author Artus Kolanowski
* @license The MIT License (MIT)
*/
;(function ($, window, document, undefined) {
  'use strict';

  /**
   * Creates the hash plugin.
   * @class The Hash Plugin
   * @param {Owl} carousel - The Owl Carousel
   */

  var Hash = function Hash(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * Hash table for the hashes.
     * @protected
     * @type {Object}
     */
    this._hashes = {};

    /**
     * The carousel element.
     * @type {jQuery}
     */
    this.$element = this._core.$element;

    /**
     * All event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'initialized.owl.carousel': $.proxy(function () {
        if (this._core.settings.startPosition == 'URLHash') {
          $(window).trigger('hashchange.owl.navigation');
        }
      }, this),
      'prepared.owl.carousel': $.proxy(function (e) {
        var hash = $(e.content).find('[data-hash]').andSelf('[data-hash]').attr('data-hash');
        this._hashes[hash] = e.content;
      }, this)
    };

    // set default options
    this._core.options = $.extend({}, Hash.Defaults, this._core.options);

    // register the event handlers
    this.$element.on(this._handlers);

    // register event listener for hash navigation
    $(window).on('hashchange.owl.navigation', $.proxy(function () {
      var hash = window.location.hash.substring(1),
          items = this._core.$stage.children(),
          position = this._hashes[hash] && items.index(this._hashes[hash]) || 0;

      if (!hash) {
        return false;
      }

      this._core.to(position, false, true);
    }, this));
  };

  /**
   * Default options.
   * @public
   */
  Hash.Defaults = {
    URLhashListener: false

    /**
     * Destroys the plugin.
     * @public
     */
  };Hash.prototype.destroy = function () {
    var handler, property;

    $(window).off('hashchange.owl.navigation');

    for (handler in this._handlers) {
      this._core.$element.off(handler, this._handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.Hash = Hash;
})(window.Zepto || window.jQuery, window, document);

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupGallery = undefined;

var _utilities = require('../../../assets/src/js/utilities');

$(document).ready(function () {
  return popupGallery();
});

function popupGallery() {
  $('.popup-gallery').each(function () {
    $(this).magnificPopup({
      delegate: '.popup-gallery-link:not(.slick-cloned)',
      type: 'image',
      closeBtnInside: false,
      fixedBgPos: true,
      fixedContentPos: true,
      mainClass: 'mfp-img-mobile',
      tLoading: 'Loading image #%curr%...',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
        arrowMarkup: '<img alt="%title%" class="m-popup-gallery-arrow mfp-arrow mfp-arrow-%dir%" src="/wp-content/themes/rezberrybud/assets/dist/images/icon-arrow-%dir%-dark.svg">',
        tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
      },
      iframe: {
        tError: '<a href="%url%">The video #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        },
        patterns: {
          youtube: {
            index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

            // id: 'v=', // String that splits URL in a two parts, second part should be %id%
            // Or null - full URL will be returned
            // Or a function that should return %id%, for example:
            // id: function(url) { return 'parsed id'; }
            id: function id(url) {
              return (0, _utilities.getParam)('v', url);
            },

            src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          },
          wistia: {
            index: 'wistia.com/',
            id: '/medias/',
            src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
          },
          gmaps: {
            index: '//maps.google.',
            src: '%id%&output=embed'
          }
        },
        markup: '<div class="mfp-iframe-scaler">' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '</div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<h5 class="mfp-counter"></h5>' + '</div>'
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        }
      }
    });
  });
}

exports.popupGallery = popupGallery;

},{"../../../assets/src/js/utilities":2}],14:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

jQuery(function ($) {
  $('.popup-iframe-link').magnificPopup({
    type: 'iframe',
    fixedBgPos: true,
    fixedContentPos: true,
    midClick: true,
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

          // id: 'v=', // String that splits URL in a two parts, second part should be %id%
          // Or null - full URL will be returned
          // Or a function that should return %id%, for example:
          // id: function(url) { return 'parsed id'; }
          id: function id(url) {
            return (0, _utilities.getParam)('v', url);
          },

          src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        },
        wistia: {
          index: 'wistia.com/',
          id: '/medias/',
          src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
        },
        gmaps: {
          index: '//maps.google.',
          src: '%id%&output=embed'
        }
      }
    }
  });
});

},{"../../../assets/src/js/utilities":2}],15:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-search-form').submit(function (e) {
      if ($(this).find('[type="search"]').val() == '') {
        e.preventDefault();
      }
    });
  });
});

},{}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
$(document).ready(function () {
  slickThis();
});
$(window).on('resize orientationchange', function () {
  slickThis();
});

function slickThis() {
  $('.slick-this:not(.slick-initialized)').each(function () {
    var adaptiveHeight = $(this).data('height'),
        arrows = $(this).data('arrows'),
        autoplay = $(this).data('autoplay'),
        dots = $(this).data('dots'),
        fade = $(this).data('fade'),
        slidesToScroll = $(this).data('scroll'),
        slidesToShow = $(this).data('show'),
        centerMode = $(this).data('centermode'),
        centerPadding = $(this).data('centerpadding');
    //$arrows = $(this).siblings('.m-slider-arrows')

    $(this).slick({
      adaptiveHeight: adaptiveHeight,
      arrows: arrows,
      autoplay: autoplay,
      dots: dots,
      fade: fade,
      infinite: false,
      mobileFirst: true,
      //nextArrow: $arrows.find('.m-slider-arrows-arrow-right'),
      //prevArrow: $arrows.find('.m-slider-arrows-arrow-left'),
      rows: 0,
      slidesToScroll: slidesToScroll,
      slidesToShow: slidesToShow,
      centerMode: centerMode,
      centerPadding: centerPadding
    });
  });
}

exports.slickThis = slickThis;

},{}],17:[function(require,module,exports){
'use strict';

// taken from https://codepen.io/team/rcrooks1969/pen/opXWww

jQuery(function () {
  if (typeof videojs == 'undefined') return;

  // Create array for player IDs
  var players = [];

  // +++  Determine the available player IDs +++//
  for (var x = 0; x < Object.keys(videojs.players).length; x++) {
    // Assign the player name to setPlayer
    var setPlayer = Object.keys(videojs.players)[x];
    // Define the ready event for the player
    videojs.getPlayer(setPlayer).ready(function () {
      // Assign this player to a variable
      var myPlayer = this;
      // Assign and event listener for play event
      myPlayer.on('play', onPlay);
      // Push the player to the players array
      players.push(myPlayer);
    });
  }

  // +++ Handle all players' play event +++//
  function onPlay(e) {
    // Determine which player the event is coming from
    var id = e.target.id;
    // Loop through the array of players
    for (var i = 0; i < players.length; i++) {
      // Get the player(s) that did not trigger the play event
      if (players[i].id() != id) {
        // Pause the other player(s)
        videojs.getPlayer(players[i].id()).pause();
      }
    }
  }
});

},{}],18:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  var ww = window.innerWidth;

  $(document).ready(function () {
    moduleShowToggle();
  });
  $(window).on('resize orientationchange', function () {
    moduleShowToggle();
  });

  function moduleShowToggle() {
    if (ww == window.innerWidth) return;
    $('.m-view-toggle').each(function () {
      var $this = $(this),
          $section = $this.parents('section'),
          cutoff = $this.data('cutoff'),
          numToShow = $this.data('num-to-show'),
          $more = $this.find('.view-more'),
          $less = $this.find('.view-less'),
          $toggleContainer = $section.find('.toggle-this-container');

      $section.find('.toggle-this:lt(' + cutoff + ')').show();
      var items = $section.find('.toggle-this').length,
          shown = cutoff;

      $more.click(function () {
        $(this).siblings('.view-less').show();
        var remaining = items - shown;
        // console.log($toggleContainer)
        if (remaining < numToShow) {
          shown = shown + remaining;
        } else {
          shown = shown + numToShow;
        }
        if (shown < items) {
          $toggleContainer.find('.toggle-this:lt(' + shown + ')').show(300);
        } else {
          $toggleContainer.find('.toggle-this:lt(' + items + ')').show(300);
          $(this).hide();
        }
      });

      if ($less.length) {
        less.click(function () {
          var hide = items - cutoff;
          $('html, body').animate({
            scrollTop: $toggleContainer.parent().offset().top
          }, 300);
          $toggleContainer.find('.toggle-this').not(':lt(' + cutoff + ')').hide(300);
          $(this).hide();
          $(this).siblings('.view-more').show();
          shown = cutoff;
        });
      }
    });

    ww = window.innerWidth;
  }
});

},{}],19:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.m-rez-hero.with-video button').on('click', function (e) {
    $(this).toggleClass('paused');
    e.preventDefault();
    var videoItem;
    if ($('.m-rez-hero-iframe-wrapper').length > 0) {
      // var iframe = document.querySelector('iframe');
      var iframe = document.getElementById('hero-video');
      videoItem = new Vimeo.Player(iframe);
      // vimeo player specific functions
      videoItem.getPaused().then(function (paused) {
        // paused = whether or not the player is paused
        if (paused) {
          videoItem.play();
        } else {
          videoItem.pause();
        }
      }).catch(function (error) {
        // an error occurred
      });
    }
    if ($('.m-rez-hero-video video').length > 0) {
      videoItem = document.getElementById('hero-video');
      // html video element functions
      if (videoItem.paused) {
        videoItem.play();
      } else {
        videoItem.pause();
      }
    }
  });

  function parallaxHeight() {
    var ww = window.innerWidth,
        ch = ww * .5625;
    if (ww >= 768) {
      if ($('.m-rez-hero-video').length > 0) {
        $('.m-rez-hero.with-video, .m-rez-hero-video, .m-rez-hero-video iframe').height(ch);
      }
    }
  }

  $(window).on('load', function () {
    parallaxHeight();
  });

  $(window).on('resize orientationchange', function () {
    parallaxHeight();
  });
});

},{}],20:[function(require,module,exports){
'use strict';

var headerHeight;

function getHeaderHeight() {
  if (window.innerWidth >= 768) {
    headerHeight = $('.m-header').height();
  } else {
    headerHeight = $('.m-tenant-nav-nav-wrapper').height();
  }
  if (headerHeight <= 0) {
    headerHeight = 66;
  }
  return headerHeight;
}

$(window).on('load', function () {
  getHeaderHeight();
  billboardHeight();
});
$(window).on('resize orientationchange', function () {
  getHeaderHeight();
  billboardHeight();
});

function pauseVideo(parent, player) {
  if (player) {
    player.getPaused().then(function (paused) {
      if (!paused) {
        player.pause();
      }
    }).catch(function (error) {
      // an error occurred
    });
    $(parent).find('.bg-video-actions .video-pause').addClass('paused');
  }
}

function playVideo(parent, player) {
  if (player) {
    player.getPaused().then(function (paused) {
      if (paused) {
        player.play();
      }
    }).catch(function (error) {
      // an error occurred
    });
    $(parent).find('.bg-video-actions .video-pause').removeClass('paused');
  }
}

$(window).scroll(function () {
  var topPos;
  var scrollTop = $(this).scrollTop(),
      windowBottom = scrollTop + $(window).height();

  $('.m-billboard-lg').each(function () {
    var topPad = 0,
        modH = $(this).height(),
        topPos = headerHeight,
        videoItem,
        iframe;
    var elPosition = $(this).offset().top;
    elPosition = elPosition - topPos;

    if ($(this).is('.with-video')) {
      iframe = $(this).find('iframe');
      if (iframe) {
        videoItem = new Vimeo.Player(iframe);
      }
    }

    if (scrollTop >= elPosition) {
      $(this).find('.bg-image').addClass('fixed').css({ top: headerHeight + 'px' });
      if (window.innerWidth >= 768) {
        if ($(this).is('.with-video')) {
          playVideo($(this), videoItem);
          $(this).find('.m-billboard-lg-video').addClass('fixed').css({ top: headerHeight + 'px' });
        }
      }

      if (scrollTop >= elPosition + modH) {
        $(this).find('.bg-image').removeClass('fixed').css('top', 'initial');
        $(this).nextAll('section:not(.m-billboard-lg)').css({ 'background-color': 'transparent', 'z-index': '2' });

        if (window.innerWidth >= 768) {
          if ($(this).is('.with-video')) {
            $(this).find('.m-billboard-lg-video').removeClass('fixed').css('top', '0');
            pauseVideo($(this), videoItem);
          }
        }
      } else {
        $(this).find('.bg-image').addClass('fixed').css('top', headerHeight + 'px');
        $(this).nextAll('section:not(.m-billboard-lg)').css({ 'background-color': '#112E4C', 'z-index': '3' });

        if (window.innerWidth >= 768) {
          if ($(this).is('.with-video')) {
            $(this).find('.m-billboard-lg-video').addClass('fixed').css('top', headerHeight + 'px');
            playVideo($(this), videoItem);
          }
        }
      }
    } else {
      $(this).find('.bg-image').removeClass('fixed').css('top', 'initial');
      $(this).nextAll('section:not(.m-billboard-lg):not(.before-testimonial)').css({ 'background-color': 'transparent', 'z-index': '2' });

      if (window.innerWidth >= 768) {
        if ($(this).is('.with-video')) {
          $(this).find('.m-billboard-lg-video').removeClass('fixed').css('top', '0');
          if (windowBottom >= elPosition) {
            playVideo($(this), videoItem);
          } else {
            pauseVideo($(this), videoItem);
          }
        }
      }
    }
  });
}).scroll();

function billboardHeight() {
  $('.m-billboard-lg').each(function () {
    var modH = $(this).height(),
        textH = $(this).find('.m-billboard-lg-prose').height();

    if ($(this).is('.with-video')) {
      $(this).height(modH);
      $(this).find('.bg-image').height(modH);
      if (window.innerWidth >= 768) {
        $(this).height(modH);
        if (textH > modH) {
          $(this).find('.m-billboard-lg-prose .col-12').css({ 'flex': '0 0 100%', 'max-width': '100%' });
          if (window.innerWidth >= 992) {
            $(this).find('.m-billboard-lg-prose .col-12').css({ 'flex': '0 0 70%', 'max-width': '70%' });
          }
          if ($(this).find('.ulr-overlay-gradient').is('.ulr-overlay-gradient-dark')) {
            $(this).find('.ulr-overlay-gradient').css('background', 'rgba(1, 11, 21, 0.85');
          }
          if ($(this).find('.ulr-overlay-gradient').is('.ulr-overlay-gradient-light')) {
            $(this).find('.ulr-overlay-gradient').css('background', 'rgba(243, 240, 234, 0.65');
          }
        }
      } else {
        if (textH > modH) {
          modH = textH + 100;
        }
        $(this).find('.bg-image, .ulr-overlay').height(modH);
        $(this).height(modH);
      }
    } else {
      if (textH > modH) {
        modH = textH + 100;
      }
      $(this).find('.bg-image').height(modH);
      $(this).height(modH);
    }
  });
}

},{}],21:[function(require,module,exports){
'use strict';

$('.m-fw-media').each(function () {
  var iframe, videoItem;
  if ($(this).is('.with-video')) {
    iframe = $(this).find('iframe');
    if (iframe) {
      videoItem = new Vimeo.Player(iframe);
    }

    //When the player is ready, set the volume to 0 - necessary for chrome accessibility things
    videoItem.ready().then(function () {
      videoItem.setVolume(0);
    });

    var inview = new Waypoint.Inview({
      element: iframe,
      enter: function enter(direction) {
        // videoItem.play();
      },
      entered: function entered(direction) {
        videoItem.play();
      },
      exit: function exit(direction) {
        videoItem.pause();
      },
      exited: function exited(direction) {
        videoItem.pause();
      }
    });
  }
});

},{}],22:[function(require,module,exports){
'use strict';

var navBreakpoint = 992,
    headerH = 77,
    windowH,
    windowW,
    modH,
    lastScrollTop = 0;

$(document).ready(function () {
  getBgSize();
});

$(window).on('load', function () {
  getBgSize();
});

$(window).on('resize orientationchange', function () {
  getBgSize();
});

// function getHeaderHeight() {
//   if( window.innerWidth >= navBreakpoint) {
//     headerHeight = $('.m-header').height()
//     if (headerHeight < 60) {
//       headerHeight = 66
//     }
//   }
//   else {
//     headerHeight = 0
//   }
//   return headerHeight
// }

// function getWindowSize() {
//   windowH = $(window).height()
//   windowW = window.innerWidth
//   return [windowH, windowW]
// }

function getBgSize() {
  windowH = $(window).height();
  windowW = window.innerWidth;

  if (window.innerWidth >= navBreakpoint) {
    headerH = $('.m-tenant-nav').height();
    if (headerH < 70) {
      headerH = 77;
    }
  } else {
    headerH = 0;
  }

  $('.m-tibg-sticky').each(function () {
    if (window.innerWidth >= navBreakpoint) {
      modH = windowH - headerH;
      $(this).find('.m-tibg-sticky-items, .m-tibg-sticky-item-bg, .m-tibg-sticky-item-bg-img').height(modH);
    } else {
      $(this).find('.m-tibg-sticky-items, .m-tibg-sticky-item-bg, .m-tibg-sticky-item-bg-img').height('auto');
    }
  });
  return [windowH, windowW, headerH, modH];
}

$(window).scroll(function () {
  var scrollTop = $(this).scrollTop(),
      windowBottom = scrollTop + windowH;
  $('.m-tibg-sticky').each(function () {
    var elPosition = $(this).find('.m-tibg-sticky-items-top').offset().top,
        nextElPosition = $(this).next('section').offset().top,
        boxesH = $(this).find('.m-tibg-sticky-item-content').height(),
        elH = boxesH + modH;

    elPosition = elPosition - headerH;
    if ($(this).next('section').length > 0) {
      nextElPosition = $(this).next('section').offset().top;
    } else {
      nextElPosition = elPosition + modH;
    }
    if (window.innerWidth >= navBreakpoint) {
      if (scrollTop >= elPosition) {
        $(this).addClass('docked');
        $(this).find('.m-tibg-sticky-items-top').height(modH - 200);
        $(this).find('.m-tibg-sticky-items').addClass('fixed').css('top', headerH);

        // at the end of the module - transition to next section
        if (windowBottom > nextElPosition) {
          $(this).find('.m-tibg-sticky-items').addClass('fixed-end').css({ 'top': 'unset', 'bottom': 0 });
        } else {
          $(this).find('.m-tibg-sticky-items').removeClass('fixed-end').css({ 'top': headerH, 'bottom': 'unset' });
        }

        $(this).find('.m-tibg-sticky-item-box.with-img').each(function () {
          var boxTop = $(this).offset().top,
              $parent = $(this).parents('.m-tibg-sticky'),
              $boxParent = $(this).parents('.m-tibg-sticky-item-content'),
              uid = $(this).data('item');
          if (windowBottom > boxTop + 200) {
            $(this).addClass('iseeyou');
            $parent.find('.active').removeClass('active');
            $parent.find('#bg-' + uid).addClass('active');
          }
        });
      } else {
        $(this).removeClass('docked');
        $(this).find('.m-tibg-sticky-items-top').height(0);
        $(this).find('.m-tibg-sticky-items').removeClass('fixed').css('top', 'initial');
      }
    } else {
      $(this).removeClass('docked');
      $(this).find('.m-tibg-sticky-items-top').height(0);
      $(this).find('.m-tibg-sticky-items').removeClass('fixed').css('top', 'initial');
    }
  });
});

},{}],23:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  tabbedSize();
});
$(window).on('resize orientationchange', function () {
  tabbedSize();
});

function tabbedSize() {
  $('.m-tctm-tabbed').each(function () {
    var $parent = $(this),
        totalHeight = 0,
        cardHeights = [];
    $parent.find('.accordion-item').each(function () {
      var headH = $(this).find('.accordion-head').outerHeight();
      totalHeight = totalHeight + headH;

      $(this).find('.accordion-collapse').map(function () {
        var cardH = $(this).outerHeight();
        cardHeights.push(cardH);
        if (window.innerWidth >= 992) {
          if (cardH >= 200) {
            $(this).parents('.accordion-item').addClass('overflow');
          } else {
            $(this).parents('.accordion-item').removeClass('overflow');
          }
        } else {
          $(this).parents('.accordion-item').removeClass('overflow');
        }
      });
    });

    var largestBody;
    var maxCardH = cardHeights.reduce(function (acc, cv) {
      if (cv > acc) {
        largestBody = cv;
      }
      return largestBody;
    }, 0);

    // totalHeight = totalHeight + maxCardH
    totalHeight = totalHeight + 200;
    if (window.innerWidth >= 992) {
      if (totalHeight < 500) {
        $(this).find('.m-tctm-tabbed-content').height(500);
      } else {
        $(this).find('.m-tctm-tabbed-content').height(totalHeight);
      }
    } else {
      $(this).find('.m-tctm-tabbed-content').height('auto');
    }

    $(this).find('.tab-pane').each(function () {
      var $paneEmbed = $(this).find('.m-tctm-tabbed-embed-snippet'),
          $paneEmbedIframe = $paneEmbed.find('.tableauPlaceholder').find('iframe'),
          paneWidth = $paneEmbed.width();

      if ($paneEmbedIframe.length > 0) {
        if (window.innerWidth >= 992) {
          $paneEmbedIframe.width(paneWidth);
          if (totalHeight < 500) {
            $paneEmbedIframe.height(500);
          } else {
            $paneEmbedIframe.height(totalHeight);
          }
        }
      }
    });

    // size tableau for mobile
    $(this).find('.m-tctm-tabbed-mobile-media').each(function () {
      var $mobileEmbed = $(this).find('.m-tctm-tabbed-embed-snippet'),
          $mobileEmbedIframe = $mobileEmbed.find('.tableauPlaceholder').find('iframe'),
          tabWidth = window.innerWidth;
      if ($mobileEmbedIframe.length > 0) {
        if (window.innerWidth < 992) {
          $mobileEmbedIframe.width(tabWidth - 30);
        }
      }
    });
  });
}

// toggle associated media for each tab
$('.accordion-head').on('click', function () {
  var $accordionParent = $(this).parents('.accordion'),
      $contentParent = $(this).parents('.m-tctm-tabbed-content'),
      accordionId = $accordionParent.attr('id');

  $accordionParent.find('.accordion-item.active').removeClass('active');
  $accordionParent.find('.tab-break.before-active').removeClass('before-active');
  $(this).parents('.accordion-item').addClass('active');
  $(this).parents('.accordion-item').prev('.tab-break').addClass('before-active');
  var loopIndex = $(this).data('index');
  $contentParent.find('.tab-pane.active').removeClass('active');
  $contentParent.find('#' + accordionId + '-media-' + loopIndex).addClass('active');

  // stop video from playing if tab switched
  var $video = $contentParent.find('.m-tctm-tabbed-video');
  $contentParent.find('.m-tctm-tabbed-video').each(function () {
    var iframe = $(this).find('iframe');

    var $videoPanelParent = $(this).parents('.accordion-collapse'),
        $videoTabParent = $(this).parents('.tab-pane'),
        videoItem = new Vimeo.Player(iframe);

    if ($videoPanelParent.not('.show')) {
      videoItem.pause();
    }
    if ($videoTabParent.is(':not(.active)')) {
      videoItem.pause();
    }
  });
});

},{}],24:[function(require,module,exports){
'use strict';

var navBreakpoint = 992,
    headerHeight = 66,
    wh2,
    windowH,
    windowW,
    modMaxH,
    lastScrollTop = 0;

$(document).ready(function () {
  stickyModHeight();
  getWindowSize();
});

$(window).on('load', function () {
  stickyModHeight();
});

$(window).on('resize orientationchange', function () {
  getWindowSize();
  stickyModHeight();
});

function getHeaderHeight() {
  if (window.innerWidth >= 768) {
    headerHeight = $('.m-header').height();
  } else {
    headerHeight = $('.m-tenant-nav-nav-wrapper').height();
  }
  if (headerHeight < 60) {
    headerHeight = 66;
  }
  wh2 = $(window).height();
  modMaxH = wh2 - headerHeight;

  return headerHeight;
}

function getWindowSize() {
  windowH = $(window).height();
  windowW = window.innerWidth;
  return [windowH, windowW];
}

$(window).scroll(function () {
  var topPos;
  var scrollTop = $(this).scrollTop(),
      windowBottom = scrollTop + windowH;
  $('.m-tctm-sticky').each(function () {
    var modH = $(this).height();
    if (windowW >= 992) {
      topPos = headerHeight;
    } else {
      topPos = 0;
    }

    var elPosition = $(this).offset().top,
        nextElPosition = $(this).next('section').offset().top;

    if ($(this).next('section').length > 0) {
      nextElPosition = $(this).next('section').offset().top;
    } else {
      nextElPosition = elPosition + modH;
    }

    elPosition = elPosition - headerHeight;
    var alreadyFixed = false;
    if (scrollTop >= elPosition) {
      alreadyFixed = true;
      $(this).not('.fixed-inner').addClass('fixed-inner');
      if (windowW < navBreakpoint) {
        $(this).find('.module-intro').find('.fade-slideup').addClass('in-always');
      }
      if (windowBottom >= nextElPosition) {
        if (windowW >= navBreakpoint) {
          $(this).removeClass('fixed-inner');
          if (!$(this).is('.with-subs')) {
            $(this).addClass('keep-fixed-inner');
          }
          if ($(this).not('.with-subs')) {}
        } else {
          if (scrollTop >= nextElPosition) {
            $(this).removeClass('fixed-inner');
            $(this).find('.mobile-placeholder').removeClass('unfix');
            alreadyFixed = false;
          } else {
            $(this).addClass('fixed-inner');
            $(this).find('.mobile-placeholder').removeClass('unfix');
            alreadyFixed = true;
            // var wh = $(window).height()
            var bottomSpace = windowH - headerHeight - windowW,
                modTop = nextElPosition - scrollTop - 375 - 100,
                $lastImgPanel;

            if (windowW > 500) {
              modTop = nextElPosition - scrollTop - windowW - 100 + headerHeight - 20;
            }
            if (windowW >= 768 && windowW < 992) {
              modTop = nextElPosition - scrollTop - 768 - headerHeight;
            }

            if ($(this).is('.with-subs')) {
              $lastImgPanel = $(this).find('.m-tctm-sticky-subsection-media:last-of-type');
            } else {
              $lastImgPanel = $(this).find('.m-tctm-sticky-subsection-media.active-panel');
            }

            if (windowBottom >= nextElPosition + bottomSpace) {
              $lastImgPanel.css('transform', 'translateY(' + modTop * 1 + 'px)');
              // $(this).find('.mobile-placeholder').addClass('unfix')
            } else {
              $lastImgPanel.css('transform', 'translateY(0)');
            }
          }
        }
      } else {
        $(this).addClass('fixed-inner');
        $(this).removeClass('keep-fixed-inner');
        $(this).find('.mobile-placeholder').removeClass('unfix');
      }
    } else {
      $(this).removeClass('fixed-inner');
      alreadyFixed = false;
    }

    $(this).find('.m-tctm-sticky-subsection-text.with-media').each(function () {
      var ssPosition = $(this).offset().top,
          ssHeight = $(this).height(),
          uid = $(this).data('uid'),
          $parent = $(this).parents('.m-tctm-sticky'),
          iframeId = 'tctm-' + uid + '-video',
          videoItem,
          iframe;

      windowBottom = windowBottom - 50;
      if (alreadyFixed == true) {
        if (ssPosition < windowBottom) {
          $parent.find('.active-panel').removeClass('active-panel');
          $parent.find('#panel-' + uid).addClass('active-panel');
        }
      }
    });

    $(this).find('.m-tctm-sticky-subsection-media-item').each(function () {
      var $parent = $(this).parents('.m-tctm-sticky-subsection-media'),
          puid = $parent.data('uid'),
          videoItem,
          iframeId,
          iframe;
      if ($(this).is('.vimeo-video')) {
        iframeId = 'tctm-' + puid + '-video';
        iframe = document.getElementById(iframeId);
        if (iframe && !$parent.is('.active-panel')) {
          videoItem = new Vimeo.Player(iframe);
          videoItem.pause();
        }
      }
    });
  });
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}).scroll();

function stickyModHeight() {
  getHeaderHeight();
  var wh = $(window).height(),
      modMaxH = windowH - headerHeight,
      mediaWidth = $('.m-tctm-sticky-subsection-media').width();
  if (window.innerWidth >= 992) {
    headerHeight = headerHeight + 7;
    $('.m-tctm-sticky-subsection-media').css({ top: headerHeight + 'px', height: modMaxH });
    $('.m-tctm-sticky-subsection-media-item').css('height', modMaxH);
    $('.m-tctm-sticky-embed > div, .m-tctm-sticky-embed > div > iframe').css({ height: modMaxH, width: mediaWidth });
  } else {
    headerHeight = headerHeight;
    if (window.innerWidth > 500) {
      modMaxH = windowW * 0.5625;
    } else if (windowW >= 768 && windowW < 992) {
      modMaxH = windowW * 0.5625;
    } else {
      modMaxH = window.innerWidth;
      headerHeight = 66;
    }
    $('.m-tctm-sticky-subsection-media, .m-tctm-sticky-media-wrapper, .mobile-placeholder').css({ top: headerHeight + 'px', height: modMaxH });
    $('.m-tctm-sticky-subsection-media-item').css('height', modMaxH);
    $('.m-tctm-sticky-embed > div, .m-tctm-sticky-embed > div > iframe').css({ height: modMaxH, width: mediaWidth });
  }
}

},{}],25:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  bracketColAlignment();
});
$(window).on('resize orientationchange', function () {
  bracketColAlignment();
});

function bracketColAlignment() {
  $('.m-brackets').each(function () {
    if ($(this).is('.all-four')) {
      var $parent = $(this);
      var tallestCol = 0;
      $parent.find('.m-brackets-cards-col').each(function () {
        var colH = 0;

        $(this).find('.m-brackets-card').map(function (a, b) {
          var cardH = $(this).outerHeight();
          colH = colH + cardH;
          return colH;
        });

        if (colH > tallestCol - 50 || colH == tallestCol) {
          tallestCol = colH;
          if (!$(this).is(':first-of-type')) {
            $(this).addClass('mt-md-5');
          }
        } else {
          $(this).parents('.m-brackets-cards-wrap').addClass('align-items-sm-center');
        }
      });
    }
  });
}

},{}],26:[function(require,module,exports){
'use strict';

// $(document).ready(function() {
//   slickThisLogos()
// })
// $(window).on('resize orientationchange', function() {
//   slickThisLogos()
// })

// function slickThisLogos() {
//   var wwidth = $(window).width();
//   $('.m-logos').each(function() {
//     var logos = $(this).find('.m-logos-logo')
//     var logoCount = logos.length
//     if ( logoCount < 5 ) {
//       $(this).addClass('under-five');
//     }

//     if ( wwidth <= 991 || logoCount > 5 ) {
//       var adaptiveHeight = $(this).data('height'),
//         arrows = $(this).data('arrows'),
//         autoplay = $(this).data('autoplay'),
//         dots = $(this).data('dots'),
//         fade = $(this).data('fade'),
//         slidesToScrollMobile = 1,
//         rtl = $(this).data('rtl')
//       $('.m-logos-logos.slick-this-logos:not(.slick-initialized)').slick({
//         adaptiveHeight: adaptiveHeight,
//         arrows: arrows,
//         autoplay: true,
//         autoplaySpeed: 50,
//         dots: dots,
//         fade: fade,
//         infinite: true,
//         mobileFirst: true,
//         rows: 0,
//         slidesToScroll: slidesToScrollMobile,
//         slidesToShow: 3,
//         rtl: rtl,
//         speed: 2000,
//         cssEase: 'linear',
//         easing: 'cubic-bezier',
//         pauseOnFocus: true,
//         pauseOnHover: true,
//         responsive: [
//           {
//             breakpoint: 567,
//             settings: {
//               dots: false,
//               arrows: false,
//               slidesToScroll: 1,
//               slidesToShow: 3,
//             }
//           },
//           {
//             breakpoint: 767,
//             settings: {
//               dots: false,
//               arrows: true,
//               slidesToScroll: 1,
//               slidesToShow: 3,
//             }
//           },
//           {
//             breakpoint: 991,
//             settings: {
//               slidesToScroll: 1,
//               slidesToShow: 4,
//               draggable: false,
//             }
//           },
//           {
//             breakpoint: 1199,
//             settings: {
//               slidesToScroll: 1,
//               slidesToShow: 5,
//               draggable: false,
//             }
//           }
//         ]
//       })
//     }
//     else {
//       if(  logoCount <= 5 ) {
//         $('.m-logos.under-five .slick-initialized').slick('unslick')
//       }
//     }
//   })
// }

$(document).ready(function () {

    $('.m-logos').each(function () {
        // $(this).owlCarousel()
        var owl = $(this).find('.owl-carousel'),
            rtl = owl.data('rtl');
        owl.owlCarousel({
            items: 5,
            loop: true,
            margin: 50,
            autoplay: true,
            autoWidth: true,
            slideTransition: 'linear',
            autoplayTimeout: 2500,
            autoplaySpeed: 2500,
            autoplayHoverPause: true,
            dots: false,
            rtl: rtl,
            responsive: {
                0: {
                    items: 1,
                    margin: 30
                    // autoWidth: false,
                },
                600: {
                    items: 3,
                    autoWidth: true,
                    margin: 20
                },
                1000: {
                    items: 5,
                    margin: 50
                }
            }
        });
    });
});

},{}],27:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    alertSize();

    if ($('.m-alert').length) {
      if (sessionStorage.getItem('alertState') != 'dismissed') {
        rezAlert();
      } else {
        $('.m-alert').hide();
        $('body').css('padding-bottom', 0);
      }
    }
  });

  $(window).on('resize orientationchange', function () {
    alertSize();
  });

  function rezAlert() {
    $('.m-alert').css('opacity', 1);

    $('.m-alert .close').on('click', function () {
      $('.m-alert').hide();
      $('body').css('padding-bottom', 0);
      sessionStorage.setItem('alertState', 'dismissed');
    });
  }

  function alertSize() {
    $('body').css('padding-bottom', 0);
    if ($('.m-alert').length) {
      var ah = $('.m-alert').height();
      $('body').css('padding-bottom', ah);
    }
  }
});

},{}],28:[function(require,module,exports){
'use strict';

$(function () {
  $(window).scroll(function () {
    var curPos = $(this).scrollTop(),
        wh = $(window).height();
    //console.log('currentPos: ' + curPos)
    var windowBottom = $(this).scrollTop() + wh;
    windowBottom = windowBottom - 100;
    //console.log('winBottom: ' + windowBottom)
    if (curPos > 500) {
      $('.back-to-top').addClass('show');
      // $('.back-to-top').fadeIn(200)
    } else {
      $('.back-to-top').removeClass('show');
    }

    // change color of back to top according to section under it 
    $('section, footer').each(function () {

      var top_of_element = $(this).offset().top;
      var bottom_of_element = $(this).offset().top + $(this).outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight() - 100;
      var top_of_screen = $(window).scrollTop();

      if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
        var theClass = $(this).attr("class").match(/bg[\w-]*\b/);
        if (theClass != null) {
          $('#backToTop').attr('data-bg', theClass[0]);
        } else {
          $('#backToTop').attr('data-bg', 'navy');
        }
      }
    }); // end changing color

  });

  $('.back-to-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 200);
  });
});

},{}],29:[function(require,module,exports){
"use strict";

$(function () {

  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  $('#dismissCookies').on('click', function () {
    $('.m-footer-cookies').hide();
    createCookie('cookie_notice_hidden', 'true', 7);
    // move hubspot chat thing back to bottom
    $('#hubspot-messages-iframe-container').addClass('no-cookie-notice');
  });

  var visited = readCookie('cookie_notice_hidden');
  if (!visited || visited !== "true") {
    $('.m-footer-cookies').css('display', 'flex');
  } else {
    // if no cookie notice shown, put hubspot chat thing at bottom
    $('#hubspot-messages-iframe-container').addClass('no-cookie-notice');
  }
});

},{}],30:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

var navBreakpoint = 768,
    st = 0;

var navWaypoint,
    $header = $('.m-header'),
    $nav = $('.js-subnav'),
    $brand = $('.m-tenant-nav-brand'),
    $navElem = $('.m-tenant-nav-nav'),
    $navWrap = $('.m-tenant-nav-nav-wrapper'),
    heroH = $('.m-rez-hero').height(),
    $activeElem,
    $navElemOverflow,
    navHeight,
    brandHeight,
    lastId,
    activeShow = $('.m-tenant-nav-active-show #active-label'),
    activeLabel;

var scrollTop = $(window).scrollTop();
var menuItems = $('.m-tenant-nav-nav-list').find("a");
// Anchors corresponding to menu items
var scrollItems = menuItems.map(function () {
  var item = $($(this).attr('href'));
  if (item.length) {
    return item;
  }
});

jQuery(function ($) {
  $(document).ready(function () {
    setNavHeight();
    setActiveForMobile();
    overflowNavDesktop();
    var scrollTop = $(window).scrollTop();
  });

  $(window).on('load', function () {
    overflowNavDesktop();
    setWaypoint();
    toggleDockSubnav();
  });

  $(window).scroll(function () {
    toggleDockSubnav();
  });

  $(window).on('resize orientationchange', function () {
    setNavHeight();
    setWaypoint();
    toggleDockSubnav();
    setActiveForMobile();
    overflowNavDesktop();
    resetDropNav();
  });

  $(window).on("scroll", onScroll);

  // toggle mobile nav dropdown 
  $(document).on('click', function (e) {
    var $navTrigger = $('.m-tenant-nav-toggle');
    if ($navTrigger !== e.target && !$navTrigger.has(e.target).length && !$(e.target).hasClass('nav-open') && $('.m-tenant-nav-toggle').hasClass('nav-open')) {
      $('.m-tenant-nav-toggle.nav-open').removeClass('nav-open');
      $('#tenant-nav-list').collapse('hide');
    }
  });
  $('.m-tenant-nav-toggle').on('click', function (e) {
    $(this).toggleClass('nav-open');
  });

  function setNavHeight() {
    navHeight = $header.outerHeight();
    if (window.innerWidth >= navBreakpoint) {
      $navElem.removeClass('collapse');
      navHeight = navHeight;
    } else {
      $navElem.addClass('collapse');
      navHeight = $navWrap.outerHeight();
    }
  }

  function onScroll(e) {
    // close nav if open when scrolling
    resetDropNav();

    // change active item when scrolling
    var fromTop = $(this).scrollTop() + 50;

    // Get id of current scroll item
    var cur = scrollItems.map(function () {
      if ($(this).offset().top - 400 < fromTop) return this;
    });
    // Get the id of the current element
    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : '';

    if (lastId !== id) {
      lastId = id;
      // Set/remove active class
      menuItems.parent().removeClass('is-active').attr('aria-current', false).end().filter('[href="#' + id + '"]').parent().addClass('is-active').attr('aria-current', true);

      // auto scroll nav bar if active item is in overflow space
      $activeElem = $('.nav-item.is-active');
      if ($activeElem.length > 0) {
        var activeElemPos = $activeElem.offset().left,
            navLeftPos = $navElem.scrollLeft(),
            activeElemW = $activeElem.width();
        if (activeElemPos - activeElemW - 70 <= navLeftPos + 70) {
          $navElem.animate({
            scrollLeft: navLeftPos - activeElemW
          }, 800);
        } else {
          if (activeElemPos >= $navElem.width() + activeElemW + 70) {
            $navElem.animate({
              scrollLeft: navLeftPos + activeElemW
            }, 800);
          }
        }
      }

      setActiveForMobile();
    }
  }

  function toggleDockSubnav() {
    var $navThing = $navWrap;
    if (window.innerWidth >= 567) {
      $navThing = $nav;
    } else {
      $navThing = $navWrap;
    }

    if (typeof navWaypoint == 'undefined') setWaypoint();
    if (typeof navWaypoint == 'undefined') return;

    var st = $(window).scrollTop(),
        wp = navWaypoint;
    if (st > wp - 15 || st > heroH) {
      if (window.innerWidth < 567) {
        $('.m-tenant-nav').removeClass('is-fixed').addClass('is-static');
      }
      $navThing.removeClass('is-static').addClass('is-fixed');
      $('.main-content section:first-of-type').css('margin-top', navHeight - 10);

      // pause bg video 
      if ($('.m-rez-hero').is('.with-video')) {
        var videoItem;
        if ($('.m-rez-hero-iframe-wrapper').length > 0) {
          // var iframe = document.querySelector('iframe')
          var iframe = document.getElementById('hero-video');
          videoItem = new Vimeo.Player(iframe);
        }
        if ($('.m-rez-hero-video video').length > 0) {
          videoItem = document.getElementById('hero-video');
        }
        videoItem.pause();
        $('.hero-video-actions .video-pause').addClass('paused');
      }
    } else {
      $navThing.removeClass('is-fixed').addClass('is-static');
      if (window.innerWidth < navBreakpoint) {
        $nav.removeClass('is-fixed').addClass('is-static');
      }
      $('.main-content section:first-of-type').css('margin-top', 0);

      // restart video 
      if ($('.m-rez-hero').is('.with-video')) {
        var videoItem;
        if ($('.m-rez-hero-iframe-wrapper').length > 0) {
          // var iframe = document.querySelector('iframe');
          var iframe = document.getElementById('hero-video');
          videoItem = new Vimeo.Player(iframe);
        }
        if ($('.m-rez-hero-video video').length > 0) {
          videoItem = document.getElementById('hero-video');
        }
        videoItem.play();
        $('.hero-video-actions .video-pause').removeClass('paused');
      }
    }
  }

  function setWaypoint() {
    if ($navWrap.length) navWaypoint = $navWrap.offset().top;
  }

  function resetDropNav() {
    if ($navElem.is('.show')) {
      $('#tenant-nav-list').collapse('hide');
      $('.m-tenant-nav-toggle.nav-open').removeClass('nav-open');
      setWaypoint();
    }
  }

  function setActiveForMobile() {
    $activeElem = $('.nav-item.is-active');
    if ($activeElem.length > 0) {
      activeLabel = $activeElem.find('a').text();
    } else {
      activeLabel = $('.m-tenant-nav-nav-list li:first-of-type').text();
    }
    activeShow.text(activeLabel);
  }

  function overflowNavDesktop() {
    var listItems = $('.m-tenant-nav-nav-list').find('li'),
        colW = $navWrap.width(),
        maxW = window.innerWidth * 0.75 - 30,
        totalW = 0;
    var navItems = listItems.map(function () {
      var itemW = $(this).outerWidth();
      totalW = totalW + itemW;
    });
    if (window.innerWidth >= navBreakpoint) {
      if (totalW > colW) {
        $navElem.addClass('overflowing more-after').removeClass('no-overflow');
      } else {
        $navElem.removeClass('overflowing').addClass('no-overflow');
      }
      setTimeout(function () {
        $navElem.removeClass('pre-load');
      }, 500);
      $navElem.on('scroll', horizontalScrollDesktop);
    } else {
      $navElem.removeClass('overflowing more-after more-before');
    }
    $('.m-tenant-nav-nav.overflowing .nav-arrows').click(function () {
      var leftPos = $navElem.scrollLeft();
      if ($(this).is('.nav-nav-prev')) {
        $navElem.animate({
          scrollLeft: leftPos - 250
        }, 800);
        if (leftPos <= 0) {
          setTimeout(function () {
            $navElem.removeClass('more-before').addClass('more-after');
          }, 850);
        }
      } else {
        $navElem.animate({
          scrollLeft: leftPos + 250
        }, 800);
        if (leftPos >= colW) {
          setTimeout(function () {
            $navElem.removeClass('more-after').addClass('more-before');
          }, 850);
        }
      }
    });
  }

  function horizontalScrollDesktop() {
    var scrollLeft = $navElem.scrollLeft(),
        width = $navElem.width(),
        scrollWidth = $navElem.get(0).scrollWidth,
        offset = 15;

    $navElem.addClass('more-before');
    if (scrollWidth - width - offset <= scrollLeft) {
      $navElem.removeClass('more-after');
    } else {
      $navElem.addClass('more-after');
      if (scrollLeft == 0) {
        $navElem.removeClass('more-before');
      }
    }
  }
});

},{"../../../assets/src/js/utilities":2}]},{},[1]);
